const fr = {
  // ==========================================
  // HEADER
  // ==========================================
  header: {
    search_placeholder: "Rechercher...",
    filter: "Filtrer",
    support: "Support",
    stock: "Stock",
    payment: "Paiement",
    exchange: "Échange",
    profile: "Profile",
    logout: "Déconnecter",
    role_admin: "Admin",
    role_assistant: "Assistant",
    role_confirmator: "Confirmateur",
    role_livreur: "Livreur",
    role_seller: "Vendeur",
  },

  // ==========================================
  // NAVBAR
  // ==========================================
  navbar: {
    section_general: "Principal",
    section_operations: "Opérations",
    section_team: "Équipe & Paiements",
    section_settings: "Réglages",
    dashboard: "Tableau de bord",
    orders: "Commandes",
    all_orders: "Toutes les commandes",
    new_order: "Nouvelle",
    delivered: "Livré",
    confirmed: "Confirmé",
    waiting_confirmation: "Attente de confirmation",
    in_follow_up: "En suivi",
    in_delivery: "En livraison",
    returned: "Retourné",
    refused: "Refusé",
    cancelled: "Annulé",
    products: "Produits",
    categories: "Catégories",
    stock_management: "Gestion de Stock",
    variants: "Variantes",
    cities: "Villes",
    configurations: "Configurations",
    scan: "Scan",
    scan_return: "Scanner le retoure",
    scan_ramassage: "Scanner au ramassage",
    team: "Équipe",
    admins: "Admins",
    sellers: "Vendeurs",
    confirmators: "Confirmateurs",
    livreur: "Livreur",
    suppliers: "Fournisseurs",
    roles: "Roles",
    black_list: "Black list",
    payments_simple: "Factures",
    payments: "Les factures",
    sallers: "Vendeurs",
    confirmators_pay: "Confirmateurs",
    system: "Système",
    integrations: "Intégrations",
    delivery: "Livraison",
    applications: "Applications",
    api_docs: "API Documentation",
    complaints: "Réclamations",
    announcements: "Annonces",
    activity_logs: "Journal d'activité",
    go_premium: "Passez à Premium",
    go_premium_desc: "Débloquez plus de fonctionnalités et boostez votre business.",
    discover_premium: "Découvrir Premium",
  },

  // ==========================================
  // DASHBOARD - COMMON
  // ==========================================
  dashboard: {
    title: "Tableau de bord",
    subtitle_seller: "Bon retour ! Voici ce qui se passe dans votre entreprise.",
    subtitle_admin: "Voici un aperçu global des performances de votre plateforme.",
    subtitle_confirmator: "Bienvenue ! Voici un aperçu de vos performances de confirmation.",
    subtitle_livreur: "Bienvenue ! Voici un résumé de vos livraisons.",
    subtitle_account: "Bon retour ! Voici ce qui se passe dans votre compte.",
    refresh: "Actualiser",
    refreshing: "Actualisation...",
    loading: "Chargement...",
    vs_last_month: "vs mois dernier",
    all: "Tout",
    search_seller: "Rechercher un vendeur...",
    all_sellers: "Tous les vendeurs",
    filter_by_status: "Filtrer par statuts...",
    unknown: "Inconnu",
    no_store: "Pas de boutique",
    refrech: "Actualiser",
    on_refrech: "Actualisation...",
  },

  // ==========================================
  // STATS CARDS
  // ==========================================
  stats: {
    revenue: "Chiffre d'affaires",
    total_purchase: "Total d'achat",
    delivery_fees: "Frais de livraison",
    net_profit: "Profit Net",
    total_orders: "Total des commandes",
    new_orders: "Nouvelle commandes",
    pending_payments: "Paiements en attente",
    pending_payment: "Paiement en attente",
    sellers_profit: "Bénéfice des vendeurs",
    confirmator_profit: "Bénéfice de confirmateur",
    delivery_rate: "Taux de livraison",
    delivery_profit: "Profit de livraison",
    orders_today: "Commandes aujourd'hui",
    in_delivery: "En livraison",
  },

  // ==========================================
  // ORDER STATUS
  // ==========================================
   status : {
    nouveau: "Nouvelle",
    confirme: "Confirmé",
    paid: "Réglé",
    reporte: "Confirmation reportée",
    nonconfirme: "Non confirmé",
    indelivery: "En livraison",
    livre: "Livré",
    "pre_a_ramasse": "Prét a ramassé",
    "Livre(paye)": "Livré (Payé)",
    pending_payment: "Paiement en attente",
    retour: "Retourné",
    refuse: "Refusé",
    "Refusé par livreur": "Refusé par livreur",
    annule: "Annulé",
    duplicated: "Dupliqué",
  
    "Attente De Ramassage": "Attente de ramassage",
    Ramassé: "Ramassé",
    Expédié: "Expédié",
    "Prèt pour expédition": "Prêt pour expédition",
    "Mise en distribution": "Mise en distribution",
    "Programmé": "Programmé",
    "Interessé": "Intéressé",
    "Reçu par livreur": "Reçu par livreur",
    "Envoyé à l'agence": "Envoyé à l'agence",
    "Reçu En Agence De Livraison": "Reçu en agence de livraison",
    "Reporté par livreur": "Reporté par livreur",
    "en voyage": "En voyage",
    "En cours de livraison": "En cours de livraison",
    "Pré ramassé": "Pré-ramassé",
    "en cours de preparation": "En cours de préparation",
    "en livraison": "En livraison",
    "En Transport": "En transport",
    "Client disponible pour livraison": "Client disponible pour livraison",
    "Recu sur agence casa": "Reçu sur agence Casa",
  
    "Demande de retour": "Demande de retour",
    "Retour client expédié": "Retour client expédié",
    "Retour vers agence casa": "Retour vers agence Casa",
    "Retour vers Agence Casa": "Retour vers agence Casa",
    "Retour Reçu Agence casa": "Retour reçu agence Casa",
    "Retour reçu agence casa": "Retour reçu agence Casa",
    "Retour reçu par agence": "Retour reçu par agence",
    "Retour reçu par livreur": "Retour reçu par livreur",
    "Retour client Reçu": "Retour client reçu",
    "Retour prêt pour l'expedition": "Retour prêt pour expédition",
    "A retourner vers agence principal casa": "À retourner vers agence principale Casa",
    "Retour expédié": "Retour expédié",
    "Retour reçu par {{city}}": "Retour reçu par {{city}}",
    "Colis prêt pour le retour": "Colis prêt pour le retour",
    "Retour en cours de la livraison": "Retour en cours de livraison",
    "Retour débarrasse": "Retour débarrassé",
    "Retour en stock": "Retour en stock",
    "retour_recu": "Retour reçu",
    "Retour client reçu": "Retour client reçu",
  
    "sans adresse": "Sans adresse",
    "Injoignable": "Injoignable",
    "Boite Vocal": "Boîte vocale",
    "Pas de réponse": "Pas de réponse",
    "pas de réponse 2 fois": "Pas de réponse 2 fois",
    "Pas de réponse 3 fois": "Pas de réponse 3 fois",
    "Pas de réponse J+2": "Pas de réponse J+2",
    "Pas de réponse J+3": "Pas de réponse J+3",
    "pas réponse + déplacement J+2": "Pas de réponse + déplacement J+2",
    "pas réponse + déplacement J+3": "Pas de réponse + déplacement J+3",
    "pas réponse +déplacement": "Pas de réponse + déplacement",
    "Pas de reponse ( SUIVI )": "Pas de réponse (SUIVI)",
    "Injoignable ( SUIVI )": "Injoignable (SUIVI)",
    "Reporté ( SUIVI )": "Reporté (SUIVI)",
    "Boite Vocal ( SUIVI )": "Boîte vocale (SUIVI)",
    "Faux destination": "Fausse destination",
    "Hors zone": "Hors zone",
    "Hors-zone": "Hors zone",
    "Pas Interessé": "Pas intéressé",
    "Produit endommagé": "Produit endommagé",
    "Perdu": "Perdu",
  
    "Demande de suivi": "Demande de suivi",
    "Annulé ( SUIVI )": "Annulé (SUIVI)",
    "Annulé par livreur": "Annulé par livreur",
    "Changement adresse": "Changement d'adresse",
    "Changement d'adresse": "Changement d'adresse",
    "Reçu par erreur": "Reçu par erreur",
    "Non reçu": "Non reçu",
    "Colis archivé": "Colis archivé",
    "reportée indéfiniment": "Reportée indéfiniment",
    "reporté aujourd hui": "Reporté aujourd'hui",
    "Erreur Numero": "Erreur numéro",
    "Remboursé": "Remboursé",
  },

  // ==========================================
  // ORDER MODEL 
  // ==========================================

  order_modal: {
    page_title: "Système de commande",
    page_subtitle: "Ajouter plusieurs clients et leurs commandes",
    grand_total: "Grand Total",
    saving: "Enregistrement...",
    save_all: "Enregistrer tout",
    client_title: "Client #{index}",
    in_stock: "In Stock",
    out_of_stock: "Out of Stock",
    percent_off: "-{value}% OFF",
    article_title: "Article #{index}",
    label_name: "Nom",
    label_phone: "Téléphone",
    label_city: "Ville",
    label_selling_price: "Prix de vente",
    label_address: "Adresse",
    label_quantity: "Quantité",
    label_comment: "Commentaire",
    label_change: "Change",
    label_unlock: "L'ouverture de colis",
    label_confirmed: "Déjà confirmé",
    total_client: "Total Client:",
    profit: "Profit :",
    enter_address: "Entrez l'adresse...",
    enter_comment: "Entrez le commentaire...",
    enter_selling_price: "Entrez le prix de vente...",
    at_least_one_client: "Vous devez avoir au moins un client.",
    fill_client_info: "Veuillez remplir toutes les informations du client (Nom, Téléphone, Ville, Adresse).",
    min_quantity: "Le client doit commander au moins une quantité.",
    valid_selling_price: "Le client doit avoir un prix de vente valide (> {price}).",
    select_variants: "Article #{index}: Veuillez sélectionner toutes les variantes requises. Manquant: {types}",
    orders_saved: "Commandes enregistrées avec succès !",
    save_failed: "Échec de l'enregistrement des commandes : {message}",
    validation_failed: "La validation a échoué. Vérifiez vos entrées.",
    save_error: "Erreur lors de l'enregistrement : {message}",
    error_generic: "Erreur : {message}",
    unexpected_city_format: "Format de données inattendu reçu de l'API des villes.",
    error_loading_cities: "Erreur lors du chargement des villes.",
  },

  // ==========================================
  // CHARTS & SECTIONS
  // ==========================================
  charts: {
    delivered_percentage: "Pourcentage Livré",
    delivered_percentage_desc: "Indique des commandes livrées.",
    confirmed_percentage: "Pourcentage Confirmé",
    confirmed_percentage_desc: "Indique des commandes confirmées.",
    orders_by_city: "Répartition des commandes par ville",
    orders_by_city_desc: "Nombre de commandes par zone géographique",
    last_payments: "Les cinq Paiements",
    last_payments_desc: "Aperçu des cinq paiements",
    top_products: "Top 5 des produits",
    top_products_desc: "Produits les plus performants",
    top_sellers: "Top 5 des vendeurs",
    top_sellers_desc: "Vendeurs les plus performants",
    top_cities: "Top 5 des villes",
    top_cities_desc: "Villes avec le plus de commandes",
    ville: "Ville",
    delivered: "Livrées",
    rate: "Taux",
    top_confirmators: "Meilleurs confirmateurs",
    top_confirmators_desc: "Indique des confirmateurs.",
    top_confirmators_alt: "Top Confirmateurs",
    top_confirmators_alt_desc: "Performance des confirmateurs.",
    paid_on: "Versé le",
    sales: "ventes",
    orders: "commandes",
    revenue_label: "revenu",
    live_activity: "Activité en direct",
    realtime_engagement: "Engagement en temps réel",
    active_users: "Utilisateurs actifs",
    page_views: "Pages vues",
    bounce_rate: "Taux de rebond",
    shortcuts: "Raccourcis",
    orders_par_days: "Commandes par jour",
    nomber_orders_par_days: "Nombre quotidien de commandes",
    total_orders: "Total commandes",
    daily_average: "Moyenne journalière",
    per_day: "par jour",
    day: "Jour",
    revenue_per_day: "Revenu par jour",
    monthly_daily_revenue: "Revenu quotidien du mois",
    total_revenue: "Revenu total",
    confirmed_orders: "Commandes confirmées",
    percentage: "Pourcentage",
    out_of_100: "sur 100%",
    no_data_available: "Aucune donnée disponible",
    delivery_time: "Temps de livraison",
    delivery_time_desc: "Distribution du temps entre expédition et livraison",


  },

  common: {
    sort: "Trier",
    sort_by: "Trier par",
    filters: "Filtres",
    alphabetical: "Alphabétique",
    newest_first: "Plus récents d'abord",
    oldest_first: "Plus anciens d'abord",
    showing: "Affichage",
    of: "sur",
    page: "Page",
    found: "trouvé",
    results: "résultats",
    retry: "Réessayer",
    previous: "Précédent",
    next: "Suivant",
    sorted_by: "Trié par",
    adjust_search: "Essayez d'ajuster vos termes de recherche ou vos filtres.",
    refresh_page_hint: "Veuillez essayer d'actualiser la page.",
    last_updated: "Dernière mise à jour",
    not_available: "N/D",
    currency: "MAD",
    this_month: "ce mois",
    updated_live: "en temps réel",
    needs_attention: "à relancer",
    view: "Voir",
    delete: "Supprimer",
  },

  filter_orders: {
    all_sellers: "Tous les vendeurs",
    all_livreurs: "Tous les livreurs",
    all_products: "Tous les produits",
    unknown: "Inconnu",
    no_store: "Pas de boutique",
    error_loading_sellers: "Erreur lors du chargement des vendeurs",
    error_loading_livreurs: "Erreur lors du chargement des livreurs",
    error_loading_products: "Erreur lors du chargement des produits",
    select_company: "Veuillez sélectionner une entreprise",
    import_google_sheets: "Importer Google Sheets",
    send: "Envoyer ({count})",
    send_to_livreur: "Envoyer au Livreur ({count})",
    confirm: "Confirmer ({count})",
    confirming: "Confirmation...",
    select_company_title: "Sélectionner une entreprise",
    confirm_send: "Confirmer l'envoi",
    scan_orders: "Scanner une commande",
    scan_orders_title: "Scanner la commande",
    scan_orders_description: "Scannez le code QR de la commande pour rechercher par code_api",
    scan_code_found: "Code scanné : {code}",
    scan_camera_error: "Impossible d'accéder à la caméra",
    scan_camera_permission: "Veuillez autoriser l'accès à la caméra dans le navigateur",
    scan_camera_https: "L'accès à la caméra nécessite une connexion sécurisée (HTTPS ou localhost)",
    scan_retry: "Réessayer",
    scan_manual_hint: "La caméra ne fonctionne pas ? Saisissez le code manuellement :",
    scan_manual_placeholder: "Entrez le code_api",
    scan_manual_search: "Rechercher",
    scan_enter_code: "Veuillez saisir un code",
  },

  products: {
    title: "Produits",
    subtitle: "Gérez efficacement votre catalogue de produits avec la recherche, le tri et les options d'affichage.",
    add_product: "Ajouter un produit",
    search_placeholder: "Rechercher des produits...",
    products_lowercase: "produits",
    product: "Produit",
    status: "Statut",
    rating: "Évaluation",
    stock: "Stock",
    price: "Prix",
    purchase_price: "Prix d'achat",
    seller_price: "Prix vendeur",
    suggested_price: "Prix suggéré",
    actions: "Actions",
    fetching_more: "Chargement d'autres produits...",
    all_loaded: "Tous les produits sont chargés",
    no_products_found: "Aucun produit trouvé",
    create_first: "Créer votre premier produit",
    unexpected_format: "Format de données inattendu reçu de l'API produits.",
    loading_error: "Erreur lors du chargement des produits.",
    pinned_success: "Produit épinglé",
    unpinned_success: "Produit désépinglé",
    pin_error: "Erreur lors de l'épinglage/désépinglage",
    unavailable_now: "Indisponible actuellement",
    limited_stock: "Stock limité",
    limited: "Limité",
    new: "Nouveau",
    new_short: "New",
    recommended_sale: "Recommandé à la vente",
    order_now: "Commandez",
    out_of_stock: "Rupture de stock",
    delete_success: "Produit supprimé avec succès",
    delete_failed: "Échec de suppression du produit",
    delete_title: "Supprimer le produit",
    delete_message: "Êtes-vous sûr de vouloir supprimer ce produit ?",
    create_title: "Créer un nouveau produit",
    create_subtitle: "Ajoutez un nouveau produit à votre catalogue avec les informations détaillées, les variantes et les affectations clients.",
    update_title: "Modifier le produit",
    update_subtitle: "Modifiez les détails du produit.",
    fetch_failed: "Échec de la récupération des données du produit.",
    id_missing: "L'ID du produit est manquant.",
    error_loading: "Erreur lors du chargement du produit",
    not_found: "Produit introuvable",
    not_found_desc: "Le produit avec l'ID n'a pas pu être chargé ou n'existe pas.",
    not_found_public: "Le produit que vous cherchez n'existe pas ou n'est pas disponible.",
    browse_other: "Parcourir d'autres produits",
    unit: "Unité",
    select_required_variants: "Veuillez sélectionner toutes les variantes requises. Manquant :",
    variant_not_available: "La combinaison de variantes sélectionnée n'est pas disponible",
    added_to_cart: "ajouté au panier !",
    in_stock: "En stock",
    product_id: "ID produit",
    off: "de réduction",
    offer_valid_until: "Offre valable jusqu'au",
    other_images: "Autres images",
    quantity: "Quantité",
    select_variants: "Sélectionner les variantes",
    item: "Article",
    details: "Détails du produit",
    units: "unités",
    product_name: "Nom du Produit *",
    status_active: "Actif",
    status_inactive: "Inactif",
    global_product: "Produit global",
    available_all_clients: "Disponible pour tous les clients par défaut",
    product_expired_soon: "Produit bientôt expiré",
    apply_discount: "Appliquer une remise",
    select_clients_hint: "Sélectionnez les clients qui peuvent accéder à ce produit :",
    no_clients_found: "Aucun client trouvé",
    drop_primary_image: "Déposez votre image principale ici",
    drop_additional_images: "Déposez vos images supplémentaires ici",
    image_formats_primary: "PNG, JPG, GIF jusqu'à 10 Mo",
    image_formats_additional: "PNG, JPG, GIF jusqu'à 10 Mo chacun",
    no_rating: "Pas d'évaluation",
    star_singular: "étoile",
    star_plural: "étoiles",
    additional_image_urls: "URLs des images supplémentaires (séparées par des virgules)",
    no_category: "Aucune catégorie",
    // --- new keys for the redesigned product detail page ---
    orders: "Commandes",
    revenue: "Revenus",
    conversion_rate: "Conversion",
    available_stock: "Stock disponible",
    average_rating: "Note moyenne",
    specifications: "Spécifications",
    reviews: "Avis",
    reviews_label: "avis",
    no_reviews: "Aucun avis pour le moment",
    no_specifications: "Aucune spécification disponible",
    no_description: "Aucune description disponible",
    no_videos: "Aucune vidéo disponible",
    shipping_returns: "Livraison & Retours",
    shipping_info_1: "Livraison estimée sous 24 à 48h partout au Maroc.",
    shipping_info_2: "Paiement à la livraison disponible.",
    shipping_info_3: "Retour accepté sous 7 jours en cas de défaut.",
    videos: "Vidéos",
    delivery: "Livraison",
    payment: "Paiement",
    cash_on_delivery: "À la livraison",
    returns: "Retour",
    days: "jours",
    warranty: "Garantie",
    quality: "Qualité",
    selling_price_label: "Prix de vente",
    estimated_profit: "Votre profit estimé",
    margin: "Marge",
    calculate_profit: "Calculez votre profit",
    recommended_selling_price: "Prix de vente recommandé",
    facebook_cost: "Coût Facebook",
    delivery_cost: "Livraison",
    price_range: "Fourchette de prix",
    selling_price: "Prix de vente",
    confirmation_fee: "Confirmation",
    total_cost: "Coût total",
    wishlist: "Favoris",
    add_to_cart: "Ajouter au panier",
    click_to_zoom: "Cliquer pour zoomer",
    added_to_wishlist: "Ajouté aux favoris",
    removed_from_wishlist: "Retiré des favoris",
    view_product: "Voir le produit",
    discount_banner_title: "Offres Spéciales",
    discount_banner_subtitle: "Profitez de nos réductions exclusives",
    discount_off: "de réduction",
    special_offer: "Offre spéciale",
    super_discounts: "Super réductions",
    on_selected_products: "sur une sélection de produits",
    discover_offers: "Découvrir les offres",
    up_to: "JUSQU'À",
    discount: "de réduction",
    profit_margin: "Marge",
  },

  categories: {
    title: "Catégories",
    subtitle: "Gérez les catégories et organisez vos produits.",
    add_category: "Ajouter une catégorie",
    search_placeholder: "Rechercher des catégories...",
    most_items: "Plus d'éléments",
    category: "catégorie",
    categories_lowercase: "catégories",
    items: "éléments",
    last_update: "Dernière mise à jour",
    no_categories_found: "Aucune catégorie trouvée",
    create_first: "Créer votre première catégorie",
    unexpected_format: "Format de données inattendu reçu de l'API catégories.",
    loading_error: "Erreur lors du chargement des catégories.",
    delete_success: "Catégorie supprimée avec succès",
    delete_failed: "Échec de suppression de la catégorie",
    delete_title: "Supprimer la catégorie",
    delete_message: "Êtes-vous sûr de vouloir supprimer cette catégorie ?",
    create_title: "Créer une nouvelle catégorie",
    create_subtitle: "Ajoutez une nouvelle catégorie pour organiser vos produits. Remplissez les détails ci-dessous pour commencer.",
    update_title: "Modifier la catégorie",
    update_subtitle: "Modifiez les détails de cette catégorie spécifique.",
    fetch_failed: "Échec de la récupération de la catégorie",
    id_missing: "L'ID de la catégorie est manquant.",
    error_loading: "Erreur lors du chargement de la catégorie",
    not_found: "Catégorie introuvable",
    not_found_desc: "La catégorie avec l'ID n'a pas pu être chargée ou n'existe pas.",
    label_title: "Titre de la Catégorie *",
    label_slug: "Slug d'URL *",
    label_image: "Image de la Catégorie",
    placeholder_title: "Entrez le titre de la catégorie...",
    placeholder_slug: "votre-slug-de-categorie",
    slug_auto_generated: "Le slug est généré automatiquement à partir du titre, mais vous pouvez le personnaliser.",
    drop_image_here: "Déposez votre image ici",
    or_click_to_browse: "ou cliquez pour parcourir les fichiers",
    accepted_formats: "PNG, JPG, GIF, WebP jusqu'à 2 Mo",
    error_title_required: "Le titre de la catégorie est requis.",
    error_title_minlength: "Le titre doit contenir au moins 3 caractères.",
    error_slug_required: "Le slug d'URL est requis.",
    error_slug_minlength: "Le slug doit contenir au moins 3 caractères.",
    error_form_validation: "Veuillez corriger les erreurs dans le formulaire.",
    error_id_missing: "Impossible de mettre à jour : l'ID de la catégorie est manquant.",
    error_auth_required: "Authentification requise. Veuillez vous connecter.",
    error_image_invalid: "Le fichier téléchargé doit être une image (PNG, JPG, GIF, WebP).",
    error_image_invalid_toast: "Veuillez télécharger une image valide (PNG, JPG, GIF, WebP).",
    error_image_size: "La taille de l'image ne doit pas dépasser {maxSize} Mo.",
    image_removed: "L'image a été supprimée. La catégorie sera mise à jour sans image si vous sauvegardez.",
    update_success: "Catégorie mise à jour avec succès !",
    error_validation_failed: "La validation a échoué. Veuillez vérifier le formulaire.",
    error_update: "Une erreur est survenue lors de la mise à jour de la catégorie.",
    error_network: "Erreur réseau ou une erreur inattendue est survenue.",
    button_cancel: "Annuler",
    button_updating: "Mise à jour...",
    button_update: "Mettre à jour",
    live_preview: "Aperçu en direct",
    zero_items: "0 éléments",
    category_title_placeholder: "Titre de la Catégorie",
    aria_upload_image: "Charger une image de catégorie",
    aria_edit_image: "Modifier l'image",
    aria_delete_image: "Supprimer l'image",
    aria_select_new_image: "Sélectionner une nouvelle image",
  },

  sellers: {
    title: "Gestion des vendeurs",
    subtitle: "Gérez les vendeurs et leur activité",
    total_sellers: "Total vendeurs",
    active_today: "Actifs aujourd'hui",
    new_this_month: "Nouveaux ce mois",
    active_sellers: "Vendeurs actifs",
    inactive_sellers: "Vendeurs inactifs",
    search_placeholder: "Rechercher des vendeurs par nom, email ou boutique...",
    sort_name: "Nom (A-Z)",
    sort_email: "Email (A-Z)",
    sellers_found: "vendeurs trouvés",
    name: "Nom",
    email: "Email",
    no_sellers_found: "Aucun vendeur trouvé",
    no_search_match: "Aucun vendeur ne correspond à vos critères de recherche.",
    none_in_system: "Il n'y a actuellement aucun vendeur dans le système.",
    loading_error: "Erreur lors du chargement des vendeurs.",
    refresh_success: "Liste des vendeurs actualisée",
    status_update_failed: "Échec de la mise à jour du statut",
    status_updated: "Statut mis à jour",
    status_update_error: "Erreur lors de la mise à jour du statut",
    delete_success: "Suppression réussie",
    delete_failed: "Échec de suppression",
    never: "Jamais",
    not_provided: "Non fourni",
    never_connected: "Jamais connecté",
    never_connected_tooltip: "Ce vendeur ne s'est jamais connecté",
    online: "En ligne",
    online_now: "En ligne",
    online_one_day: "En ligne (1j)",
    inactive: "Inactif",
    updating: "Mise à jour...",
    active: "Active",
    disabled: "Désactive",
    total_sales: "Ventes totales",
    registered_on: "Inscrit le",
    edit_seller: "Modifier",
    view_details: "Voir les détails",
    delete_title: "Supprimer le vendeur",
    delete_message: "Êtes-vous sûr de vouloir supprimer le vendeur ?",
    bank: "Banque",
    total_profit: "Profit total",
    delivered_orders: "Commandes livrées",
    in_delivery: "En livraison",
    edit_profile: "Modifier le profil",
    update_success: "Profil mis à jour avec succès !",
    update_failed: "Échec de la mise à jour du profil",
    no_data: "Aucune donnée de vendeur trouvée",
    load_error: "Erreur lors du chargement des données",
    store_label: "Store :",
    trust_score: "Trust Score",
    personal_information: "Informations personnelles",
    full_name: "Nom complet",
    email_address: "Adresse e-mail",
    phone_number_label: "Numéro de téléphone",
    address_label: "Adresse",
    store_logo: "Logo du magasin (Optionnel)",
    current_logo: "Logo actuel",
    no_logo: "Aucun logo téléchargé",
    business_information: "Informations commerciales",
    store_name: "Nom du magasin",
    seller_level: "Niveau du vendeur",
    bank_name: "Nom de la banque",
    rib_label: "RIB",
    beginner: "Débutant",
    intermediate: "Intermédiaire",
    advanced: "Avancé",
    save_changes: "Mettre à jour",
    sort_last_login: "Dernière connexion",
    orders: "Commandes",
    revenue: "CA total",
    products: "Produits",
  },

  // ==========================================
  // BUTTONS
  // ==========================================
  buttons: {
    save: "Enregistrer",
    cancel: "Annuler",
    add: "Ajouter",
    delete: "Supprimer",
    edit: "Modifier",
    back: "Retour",
    submit: "Soumettre",
    search: "Rechercher",
    reset: "Réinitialiser",
    updating: "Mise à jour...",
    update_product: "Mettre à jour le produit",
    saving: "Enregistrement...",
    confirm: "Confirmer",
  },

  // ==========================================
  // TABLES
  // ==========================================
  tables: {
    headers: {
      phone: "Téléphone",
      city: "Ville",
      status: "Statut",
      crbt: "CRBT",
      fee: "Frais",
      net: "Net",
      name: "Nom",
      email: "Email",
      action: "Action",
      date: "Date",
      total: "Total",
    },
  },

  // ==========================================
  // MESSAGES
  // ==========================================
  messages: {
    updating_orders: "Mise à jour des commandes en cours…",
    success: "Succès!",
    error: "Erreur",
    warning: "Attention",
    confirm: "Êtes-vous sûr?",
    network_error: "Erreur réseau",
    product_created_successfully: "Produit créé avec succès!",
    new_product_added: "Votre nouveau produit a été ajouté au catalogue.",
    product_updated: "Produit mis à jour avec succès !",
    product_updated_desc: "Votre produit a été mis à jour dans le catalogue.",
    update_error: "Erreur lors de la mise à jour du produit. Veuillez vérifier le formulaire.",
    validation_failed: "La validation a échoué. Veuillez vérifier le formulaire.",
    update_product_error: "Erreur lors de la mise à jour du produit : {message}",
    unexpected_error: "Une erreur inattendue s'est produite.",
    network_error_desc: "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
  },

  // ==========================================
  // FORMS
  // ==========================================
  forms: {
    sections: {
      basic_information: "Informations de base",
      pricing_inventory: "Prix et stock",
      product_images: "Images du produit",
      user_role: "Rôle de l'utilisateur",
      admin_info: "Informations de l'administrateur",
      delivery_info: "Informations de livraison",
      assistant_role_specific: "Rôle Spécifique de l'Assistant",
      role_examples: "ex: Administrateur, Éditeur, Gestionnaire Produits",
      client_assignment: "Affectation des clients",
      product_rating: "Évaluation du produit",
    },
    labels: {
      product_name: "Nom du produit *",
      description: "Description",
      primary_image: "Image principale *",
      additional_image_urls: "URLs d'images supplémentaires (séparées par des virgules)",
      fournisseur: "Fournisseur *",
      category: "Catégorie *",
      status: "Statut",
      email: "Adresse e-mail *",
      password: "Mot de passe *",
      confirm_password: "Confirmez le mot de passe *",
      role_type: "Type de Rôle *",
      gender: "Sexe *",
      phone: "Numéro de téléphone *",
      achat_price: "Prix d'achat *",
      purchase_price: "Prix d'achat *",
      seller_price: "Prix de vendeur *",
      selling_price: "Prix de vente *",
      stock_quantity: "Quantité en stock *",
      supplier_name: "Nom du Fournisseur *",
      contact_name: "Nom du Contact *",
      delivery_person_name: "Nom du Livreur *",
      delivery_price: "Prix de livraison (DH) *",
      rib: "RIB (Optionnel)",
      role_name: "Nom du rôle *",
      contact_person_name: "Nom de la personne de contact *",
      discount: "Remise (%)",
      discount_percent: "Remise (%)",
      discount_start_date: "Date de début de remise *",
      discount_end_date: "Date de fin de remise *",
      rating: "Évaluation (1 à 5 étoiles)",
    },
    placeholders: {
      enter_name: "Entrez le nom...",
      enter_phone: "Entrez le téléphone...",
      enter_email: "Entrez l'email...",
      enter_address: "Entrez l'adresse...",
      enter_comment: "Entrez le commentaire...",
      choose_city: "Choisissez une ville...",
      describe_postpone_reason: "Décrivez la raison du report...",
      describe_cancellation_reason: "Décrivez la raison de l'annulation...",
      add_additional_details: "Ajouter des détails supplémentaires...",
      search_orders: "Rechercher commandes...",
      search_seller: "Rechercher un vendeur...",
      search_delivery_person: "Rechercher un livreur...",
      search_products: "Rechercher produits",
      search_roles: "Rechercher les rôles par nom...",
      search_variants: "Rechercher les variantes...",
      search_confirmators: "Rechercher les confirmateurs...",
      search_by_order_code: "Rechercher par code de commande...",
      drag_drop_invoice: "Glissez votre facture PDF ici",
      enter_product_name: "Entrez le nom du produit...",
      enter_product_description: "Entrez la description du produit...",
      select_fournisseur: "Sélectionnez un fournisseur",
      select_category: "Sélectionnez une catégorie",
      drop_primary_image: "Déposez votre image principale ici",
      or_click_to_browse: "ou cliquez pour parcourir les fichiers",
      drop_additional_images: "Déposez vos images supplémentaires ici",
      enter_additional_image_urls: "Entrez des URLs d'images supplémentaires, ex: url1.jpg, url2.png",
      enter_discount: "Entrez la remise",
      search_clients: "Rechercher et sélectionner des clients...",
    },
    variant: {
      variant_product: "Produit à variantes",
      available_default: "Disponible pour tous les clients par défaut",
      dimensions: "Dimensions des variantes",
      color: "Couleur",
      size: "Taille",
      choose_hint: "Choisissez Couleur seulement, Taille seulement, ou les deux.",
      select_option: "Chaque option sélectionnée est une variante vendable ; toutes les lignes utilisent les mêmes dimensions.",
      no_colors: "Aucune couleur définie dans les paramètres de variantes.",
      no_sizes: "Aucune taille définie dans les paramètres de variantes.",
      add_color_size: "Ajoutez au moins une couleur et une taille dans les paramètres de variantes pour utiliser la grille couleur × taille.",
      color_size: "Couleur / Taille",
      color: "Couleur",
      size: "Taille",
      include: "Inclure",
    },
    global_product: "Produit global",
    available_all_default: "Disponible pour tous les clients par défaut",
    client_assignment: "Affectation des clients",
    select_clients: "Sélectionnez les clients qui peuvent accéder à ce produit :",
    search_clients: "Rechercher et sélectionner des clients...",
    no_clients_found: "Aucun client trouvé",
    product_rating: "Évaluation du produit",
    rating_stars: "Évaluation (1 à 5 étoiles)",
    no_rating: "Aucune évaluation",
    product_expired_soon: "Produit bientôt expiré",
    apply_discount: "Appliquer une remise",
  },

  // ==========================================
  // SELECT DATE
  // ==========================================
  date: {
    today: "Aujourd'hui",
    this_month: "Ce mois",
    last_30_days: "Derniers 30 jours",
    last_6_months: "Derniers 6 mois",
    last_12_months: "Derniers 12 mois",
    all_period: "Toute la période",
    custom_period: "Période personnalisée",
    select_period: "Sélectionnez une période",
    cancel: "Annuler",
    apply: "Appliquer",
    months_short: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"],
    months_long: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
    days_short: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
  },

  // ==========================================
  // ERROR MESSAGES
  // ==========================================
  errors: {
    unexpected_format: "Format de données inattendu reçu de l'API.",
    loading_stats: "Erreur lors du chargement des statistiques.",
    loading_sellers: "Erreur lors du chargement des vendeurs",
    auth_token_missing: "Jeton d'authentification introuvable",
    request_timeout: "Délai de la requête dépassé - Veuillez réessayer",
    no_active_announcements: "Aucune annonce active",
    fetching_announcements: "Erreur lors de la récupération des annonces",
  },
  // ==========================================
  // ORDERS PAGE
  // ==========================================
  orders: {
    delivery_tickets: "Tickets de Livraison",
    no_order_selected: "Aucune commande sélectionnée",
    assigned_success: "commande(s) assignée(s) au livreur avec succès",
    assign_error: "Erreur lors de l'assignation des commandes",
    network_error: "Erreur réseau lors de l'assignation des commandes",
    send_error: "Erreur lors de l'envoi des commandes",
    send_network_error: "Erreur réseau lors de l'envoi des commandes",
    confirm_success: "commande(s) confirmée(s) avec succès",
    confirm_error: "Erreur lors de la confirmation des commandes",
    confirm_modal_title: "Confirmer les commandes",
    confirm_modal_message: "Vous êtes sur le point de confirmer {count} commande(s). Cette action est irréversible.",
    preparing_orders: "Préparation des commandes...",
    other_products: "Plus",
    sending_orders: "Envoi en cours...",
    sending_completed: "Envoi terminé !",
    error_sending: "Erreur lors de l'envoi",
    processing: "Traitement...",
    progress: "Progression",
    orders_processed: "commandes traitées",
    orders_not_sent: "commande(s) non envoyée(s)",
    order_id: "Commande ID:",
    unknown_reason: "Raison inconnue",
    close: "Fermer",
    all_orders: "Toutes les Commandes",
    orders: "Les Commandes",
    manage_track_orders: "Gérez et suivez vos commandes",
    orders_list: "Liste des Commandes",
    showing: "Affichage",
    to: "à",
    of: "sur",
    orders_lowercase: "commandes",
    orders_selected: "commande(s) sélectionnée(s)",
    code: "Code",
    affiliate: "Affilié",
    client: "Client",
    products: "Produits",
    status: "Statut",
    total: "Total",
    profit: "Bénéfice",
    actions: "Actions",
    no_order_found: "Aucune commande trouvée",
    no_order_found_desc: "Aucune commande ne correspond au filtre sélectionné.",
    all_sent_success: "Toutes les commandes ont été envoyées avec succès",
    sent_success_count: "commande(s) envoyée(s) avec succès",
    failed_count: "échouée(s)",
    fetch_failed: "Échec de la récupération de la commande",
    fetch_updated_failed: "Échec de la récupération de la commande mise à jour",
    update_failed: "Échec de la mise à jour",
    update_success: "Commande mise à jour avec succès !",
    load_failed: "Échec du chargement des détails de la commande",
    order_label: "Commande",
    created_at: "Créée le",
    order_details: "Détails de la commande",
    name: "Nom",
    phone: "Téléphone",
    city: "Ville",
    address: "Adresse",
    select_city: "Sélectionnez une ville",
    articles: "Articles",
    add_product: "Ajouter un produit...",
    summary: "Résumé",
    subtotal: "Sous-total",
    delivery: "Livraison",
    confirmation_agent: "Agent de confirmation",
    available: "Disponible",
    contact: "Contacter",
    no_agent: "Aucun agent de confirmation assigné",
    phone_label: "Téléphone :",
    order_status: "Statut de la commande",
    change: "Change",
    unlockable: "Ouverture de colis",
    comment: "Commentaire commande",
    add_comment: "Ajouter un commentaire...",
    no_comment: "Aucun commentaire",
    history: "Historique",
    reason: "Raison :",
    postponed_to: "Reporté au :",
    comment_label: "Commentaire :",
    yes: "Oui",
    no: "Non",
    variant_required: "Veuillez sélectionner toutes les variantes requises. Manquant :",
    variant_not_available: "La combinaison de variantes sélectionnée n'est pas disponible",
    delete_success: "Commande supprimée avec succès",
    delete_failed: "Échec de la suppression de la commande",
    change_label: "Modifier",
    cost_label: "Coût",
    change_status_title: "Changer le statut",
    history_title: "Historique",
    view_title: "Voir",
    edit_title: "Modifier",
    delete_title: "Supprimer",
    delete_modal_title: "Supprimer la commande",
    delete_modal_message: "Êtes-vous sûr de vouloir supprimer cette commande ?",
  },

  // ==========================================
  // PAYMENTS
  // ==========================================
  payments: {
    sellers_title: "Paiements des Vendeurs",
    subtitle: "Gérez et générez les paiements pour tous les vendeurs de votre plateforme.",
    import_ozon: "Importe Ozon Facture",
    export_excel: "Exporter l'excel",
    generate: "Générer les paiements",
    total_invoices: "Total des factures",
    pending_invoices: "Factures en attente",
    paid_invoices: "Factures payées",
    total_amount: "Montant total",
    search_placeholder: "Rechercher par nom, boutique, numéro de facture ou email...",
    invoice: "Facture",
    seller: "Vendeur",
    bank: "Banque",
    orders: "Commandes",
    amount: "Montant",
    payment_date: "Date paiement",
    status: "Statut",
    actions: "Actions",
    not_found: "Aucune facture trouvée",
    not_found_desc: "Essayez d'ajuster vos termes de recherche ou générez de nouvelles factures.",
    generate_invoices: "Générer des factures",
    invoice_singular: "facture trouvée",
    invoice_plural: "factures trouvées",
    per_page: "Par page",
    showing: "Affichage",
    to: "à",
    on: "sur",
    results: "résultats",
    error_occurred: "Une erreur s'est produite",
    not_available: "N/A",
    status_paid: "Payé",
    status_pending: "En attente",
    status_cancelled: "Annulé",
    status_unknown: "Inconnu",
    payment_cash: "Espèces",
    payment_cheque: "Chèque",
    payment_bank_transfer: "Virement bancaire",
    payment_credit_card: "Carte de crédit",
    payment_not_specified: "Non spécifié",
    seller_unknown: "Vendeur inconnu",

    confirmators: {
      title: "Paiements Confirmateurs",
      subtitle: "Gérez et générez les paiements pour tous les confirmateurs de votre plateforme.",
      export_excel: "Exporter vers Excel",
      salary_payments: "Paiements des salaires",
      generate_payments: "Générer les paiements",
      modal_title: "Sélectionner les confirmateurs pour le paiement des salaires",
      x_of_y_selected: "{count} sur {total} sélectionné(s)",
      select_all: "Tout sélectionner",
      deselect_all: "Tout désélectionner",
      unpaid_orders: "{count} commande(s)",
      no_confirmators_found: "Aucun confirmateur trouvé pour le paiement des salaires",
      cancel: "Annuler",
      generating: "Génération...",
      generate_invoices_count: "Générer les factures ({count})",
      total_invoices: "Total des factures",
      pending_invoices: "Factures en attente",
      paid_invoices: "Factures payées",
      total_amount: "Montant total",
      search_placeholder: "Rechercher par nom de confirmateur, email ou numéro de facture...",
      invoice_found: "{count} facture(s) trouvée(s)",
      table_invoice: "Facture",
      table_confirmator: "Confirmateur",
      table_orders: "Commandes",
      table_amount: "Montant",
      table_payment_date: "Date paiement",
      table_status: "Statut",
      table_actions: "Actions",
      no_invoices: "Aucune facture trouvée",
      no_invoices_desc: "Essayez d'ajuster vos termes de recherche ou générez de nouvelles factures.",
      generate_invoices_btn: "Générer les factures",
      pagination: "Affichage {from} à {to} sur {total} résultats",
      payment_cash: "Espèces",
      payment_cheque: "Chèque",
      payment_bank_transfer: "Virement bancaire",
      payment_credit_card: "Carte de crédit",
      payment_not_specified: "Non spécifié",
      status_paid: "Payé",
      status_pending: "En attente",
      status_cancelled: "Annulé",
      status_unknown: "Inconnu",
      not_available: "N/A",
      no_email: "Aucun email",
      orders: "Commandes",
      fetch_failed: "Échec de la récupération des factures",
      fetch_failed_confirmators: "Échec de la récupération des confirmateurs",
      fetch_error: "Une erreur est survenue lors de la récupération des confirmateurs",
      select_required: "Veuillez sélectionner au moins un confirmateur",
      generate_success: "Factures générées avec succès",
      generate_failed: "Échec de la génération des factures",
      generate_error: "Une erreur est survenue lors de la génération des factures",
      error_occurred: "Une erreur est survenue",
    },

    livreurs: {
      title: "Paiements Livreurs",
      subtitle: "Gérez et générez les paiements pour tous les livreurs de votre plateforme.",
      generate_payments: "Générer les paiements",
      total_invoices: "Total des factures",
      pending_invoices: "Factures en attente",
      paid_invoices: "Factures payées",
      total_amount: "Montant total",
      search_placeholder: "Rechercher par nom de livreur, email ou numéro de facture...",
      invoice_found: "{count} facture(s) trouvée(s)",
      table_invoice: "Facture",
      table_livreur: "Livreur",
      table_orders: "Commandes",
      table_amount: "Montant",
      table_payment_date: "Date paiement",
      table_status: "Statut",
      table_actions: "Actions",
      no_invoices: "Aucune facture trouvée",
      no_invoices_desc: "Essayez d'ajuster vos termes de recherche ou générez de nouvelles factures.",
      generate_invoices_btn: "Générer les factures",
      pagination: "Affichage {from} à {to} sur {total} résultats",
      payment_cash: "Espèces",
      payment_cheque: "Chèque",
      payment_bank_transfer: "Virement bancaire",
      payment_credit_card: "Carte de crédit",
      payment_not_specified: "Non spécifié",
      status_paid: "Payé",
      status_pending: "En attente",
      status_cancelled: "Annulé",
      status_unknown: "Inconnu",
      not_available: "N/A",
      orders: "Commandes",
      fetch_failed: "Échec de la récupération des factures",
      fetch_error: "Une erreur est survenue lors de la récupération des factures",
      error_occurred: "Une erreur est survenue",
    },

    system: {
      title: "Paiements Système",
      subtitle: "Les frais de système",
      refresh: "Actualiser",
      confirm_payment: "Confirmer le paiement",
      confirm_message: "Êtes-vous sûr de vouloir marquer ce paiement comme réglé ?",
      amount_label: "Montant:",
      cancel: "Annuler",
      confirm_button: "Confirmer",
      paid_success: "Paiement réglé",
      update_failed: "Échec de la mise à jour",
      unpaid: "Impayé",
      total_amount: "Montant total",
      pay_button: "Régler",
      payment_completed: "Paiement effectué",
      no_payments: "Aucun paiement trouvé",
      paid_status: "Réglé",
      pay_full: "Payer le total",
      pay_partial: "Payer un montant",
      enter_amount: "Entrez le montant...",
      invalid_amount: "Montant invalide",
    },
  },

  // ==========================================
  // ANNONCES
  // ==========================================
  annonces: {
    success_title: "Annonce mise à jour avec succès !",
    success_desc: "Votre annonce a été modifiée avec succès.",
    label_content: "Contenu de l'Annonce *",
    placeholder_content: "Rédigez votre annonce ici...",
    label_start_date: "Date de Début *",
    label_end_date: "Date de Fin *",
    label_color: "Couleur de l'Annonce *",
    color_teal: "Teal",
    color_coral: "Coral",
    color_amber: "Amber",
    color_blue: "Bleu",
    color_purple: "Violet",
    color_green: "Vert",
    error_content_required: "Le contenu de l'annonce est requis.",
    error_content_minlength: "L'annonce doit contenir au moins 10 caractères.",
    error_start_date_required: "La date de début est requise.",
    error_end_date_required: "La date de fin est requise.",
    error_end_date_after: "La date de fin doit être postérieure à la date de début.",
    error_color_required: "La couleur est requise.",
    error_form_validation: "Veuillez corriger les erreurs dans le formulaire.",
    error_update: "Erreur lors de la mise à jour de l'annonce",
    error_unexpected: "Une erreur inattendue est survenue. Veuillez réessayer.",
    preview_title: "Aperçu de l'Annonce",
    preview_placeholder: "Votre annonce apparaîtra ici...",
    preview_start: "Date de début",
    preview_end: "Date de fin",
    preview_start_label: "Début:",
    preview_end_label: "Fin:",
    preview_duration_label: "Durée:",
    characters: "caractères",
    days: "jour(s)",
    button_cancel: "Annuler",
    button_updating: "Mise à jour...",
    button_update: "Mettre à jour l'Annonce",
    update_success: "Annonce mise à jour avec succès !",
    status_active: "Active",
    status_upcoming: "À venir",
    status_expired: "Expirée",
    start_label: "Début :",
    end_label: "Fin :",
    days_remaining: "{count} jour(s) restant(s)",

    page_title: "Annonces",
    page_subtitle: "Gérez vos annonces et communications avec vos clients.",
    new_annonce: "Nouvelle Annonce",
    search_placeholder: "Rechercher dans les annonces...",
    sort_label: "Trier",
    sort_by: "Trier par",
    sort_date_start: "Date de début",
    sort_date_end: "Date de fin",
    sort_created_at: "Date de création",
    sort_content: "Contenu (A-Z)",
    filter_all: "Toutes ({count})",
    filter_active: "Actives ({count})",
    filter_upcoming: "À venir ({count})",
    filter_expired: "Expirées ({count})",
    results_count: "{count} annonce(s) trouvée(s)",
    load_error: "Erreur de chargement",
    retry: "Réessayer",
    not_found: "Aucune annonce trouvée",
    not_found_short: "Aucune annonce",
    not_found_desc_search: "Essayez d'ajuster vos filtres de recherche",
    not_found_desc_first: "Commencez par créer votre première annonce",
    create_button: "Créer une annonce",
    create_title: "Ajouter Nouvelle Annonce",
    create_subtitle: "Ajoutez une nouvelle annonce à votre réseau avec ses informations et coûts associés.",
    id_missing: "L'ID de l'annonce est manquant.",
    auth_required: "Vous n'êtes pas authentifié. Veuillez vous connecter.",
    token_missing: "Jeton d'authentification introuvable. Veuillez vous connecter.",
    fetch_failed: "Échec de la récupération de l'annonce",
    fetch_error_log: "Erreur lors de la récupération de l'annonce :",
    fetch_unexpected_error: "Une erreur inattendue est survenue lors de la récupération de l'annonce.",
    toast_error_prefix: "Erreur",
    load_failed: "Échec du chargement de l'annonce.",
    fetch_error_title: "Erreur lors du chargement de l'annonce",
    not_found_id: "Annonce Introuvable",
    not_found_id_desc: "L'annonce avec l'ID \"{id}\" n'a pas pu être chargée ou n'existe pas.",
    update_title: "Modifier l'Annonce",
    update_subtitle: "Modifiez les détails de cette annonce spécifique.",
    load_error_msg: "Erreur lors du chargement des annonces",
    error_prefix: "Erreur: {msg}",
  },

  // ==========================================
  // RECLAMATIONS
  // ==========================================
  reclamations: {
    title: "Réclamations",
    subtitle: "Gérez vos réclamations",
    search_placeholder: "Rechercher par code de commande...",
    fetch_failed: "Échec de la récupération des réclamations",
    refresh_failed: "Échec de l'actualisation des réclamations",
    error_title: "Erreur de chargement des réclamations",
    retry: "Réessayer",
    filter_all: "Toute",
    filter_not_seen: "Pas ouvert",
    filter_seen: "Ouvert",
    results_count: "{count} réclamation(s) trouvée(s)",
    not_found: "Aucune réclamation trouvée",
    not_found_desc: "Essayez d'ajuster vos termes de recherche ou vos filtres.",
    order_label: "Commande",
    client_label: "Client",
    total_label: "Total",
    created_at: "Créée le",
    last_message: "Dernier message",
    no_messages: "Aucun message",
    open: "Ouvrir",
  },

  // ==========================================
  // API DOCUMENTATION
  // ==========================================
  api_docs: {
    hero_badge: "API sécurisée",
    hero_title: "API Documentation",
    hero_subtitle: "Intégrez vos commandes à vos propres applications et outils. Notre API REST vous permet de récupérer et de gérer vos données de vente de manière automatisée et sécurisée.",
    base_url: "URL de base",
    secured_label: "Connexion sécurisée",
    tab_documentation: "Documentation",
    tab_keys: "Clés API",
    tab_webhook: "Webhook",
    webhook_title: "Webhook des changements de statut",
    webhook_subtitle: "Recevez une requête POST sur votre URL à chaque changement de statut d'une commande (Admin, Confirmateur ou Livreur).",
    webhook_enabled: "Actif",
    webhook_disabled: "Inactif",
    webhook_url_label: "URL de callback (webhook)",
    webhook_url_placeholder: "https://votre-app.com/webhook/order-status",
    webhook_save: "Enregistrer & tester",
    webhook_save_only: "Enregistrer",
    webhook_check_label: "Activer / désactiver le webhook",
    webhook_saving: "Enregistrement...",
    webhook_save_error: "URL ou clé API en échec de test. Vérifiez que l'URL est atteignable et renvoie un code 2xx.",
    webhook_active_msg: "URL active : les changements de statut y sont envoyés.",
    webhook_inactive_msg: "L'URL est enregistrée mais le dernier test a échoué.",
    webhook_how_title: "Comment ça fonctionne ?",
    webhook_how_desc: "À chaque changement de statut de vos commandes, une requête POST est envoyée à l'URL ci-dessus avec l'en-tête X-API-Key contenant votre clé API.",
    webhook_how_example: "Envoyez une réponse 200/2xx pour marquer l'URL comme active.",
    webhook_api_key_title: "Votre clé API (importante)",
    webhook_api_key_note: "Cette clé est envoyée dans l'en-tête X-API-Key de chaque webhook. Sauvegardez-la en lieu sûr.",
    webhook_fields_title: "Champs envoyés",
    webhook_field_order_id: "order_id / order_code / code_api",
    webhook_field_status: "old_status / new_status",
    webhook_field_meta: "updated_by / updated_at",
    webhook_field_other: "saller_id / total",
    webhook_save_success: "Webhook URL enregistrée",
    webhook_status_true: "Webhook activé",
    webhook_status_false: "Webhook désactivé",
    webhook_open_docs: "Voir la documentation",
    webhook_not_found: "Aucune clé API générée. Cliquez sur \"Enregistrer & tester\" pour en créer une automatiquement.",
    overview_title: "Vue d'ensemble",
    overview_desc: "L'API REST de vente vous donne un accès programmatique à vos commandes et plus encore. Elle utilise un format JSON, des méthodes HTTP standards et une authentification par clé API dans l'en-tête.",
    auth_title: "Authentification",
    auth_desc: "Toutes les requêtes doivent inclure un en-tête X-API-Key avec votre clé API. Les requêtes sans clé valide renverront une erreur 401 Unauthorized.",
    header_example: "header de requête",
    endpoints_title: "Endpoints",
    endpoint_orders: "Récupère la liste des commandes du vendeur.",
    endpoint_cities: "Récupère la liste des villes avec leurs frais de livraison.",
    endpoint_products: "Récupère la liste des produits du vendeur (avec variantes et SKU).",
    endpoint_create_order: "Crée une nouvelle commande et retourne le code généré.",
    filter_category: "Filtrer par identifiant de catégorie.",
    filter_search: "Rechercher par nom ou description.",
    order_name: "Nom complet du client.",
    order_phone: "Numéro de téléphone du client.",
    order_city: "Ville du client.",
    order_address: "Adresse du client.",
    order_comment: "Commentaire sur la commande.",
    order_sku: "SKU du produit ou de la variante (ex: NEXT-5 ou VAR-5-2).",
    order_sku_note: "Si le produit a des variantes, envoyez le SKU du groupe de variantes (VAR-...). Si le produit n'a pas de variantes, envoyez simplement le SKU du produit (NEXT-...).",
    order_quantity: "Quantité de l'article.",
    filters: "Filtrer par statut (nouveau, confirme, livre, retour, annule, refuse).",
    per_page: "Nombre de résultats par page (défaut 15, max 100).",
    secured: "Sécurisé",
    params_title: "Paramètres",
    responses_title: "Codes de réponse",
    optional: "optionnel",
    required: "requis",
    examples_title: "Exemples de code",
    response_title: "Exemple de réponse",
    errors_title: "Codes d'erreur",
    error_code: "Code",
    error_message: "Message",
    error_desc: "Description",
    err_401_msg: "Unauthorized",
    err_401_desc: "Clé API manquante ou invalide.",
    err_422_msg: "Unprocessable Entity",
    err_422_desc: "Paramètres de requête invalides.",
    err_500_msg: "Internal Server Error",
    err_500_desc: "Erreur interne du serveur.",
    cta_title: "Prêt à commencer ?",
    cta_desc: "Générez votre clé API pour commencer à intégrer nos services.",
    cta_btn: "Générer une clé",
    generate_title: "Générer une clé API",
    generate_subtitle: "Créez une nouvelle clé pour sécuriser l'accès à l'API.",
    generate_btn: "Générer",
    generating: "Génération...",
    generate_hint: "La clé n'est affichée qu'une seule fois après sa génération. Elle ne sera plus jamais visible.",
    key_name_placeholder: "Nom de la clé (ex: Mon application)",
    key_warning: "Copiez cette clé immédiatement - elle ne sera plus jamais affichée.",
    key_generated: "Clé API générée avec succès",
    key_revoked: "Clé API révoquée",
    active_keys: "clé(s) active(s)",
    last_created: "Dernière création",
    manage_keys: "Gérer mes clés API",
    no_keys: "Aucune clé API",
    no_keys_desc: "Générez votre première clé pour commencer.",
    created: "Créée le",
    last_used: "Dernière utilisation",
    revoke: "Révoquer",
    revoke_confirm: "Êtes-vous sûr de vouloir révoquer cette clé API ? Cette action est irréversible.",
    copy: "Copier",
    copied: "Copié !",
    copy_failed: "Échec de la copie",
    error: "Une erreur est survenue, veuillez réessayer.",
    security_title: "Sécurité de la clé",
    security_desc: "Ne partagez jamais votre clé API. Stockez-la dans un endroit sûr et révoquez-la immédiatement si elle est compromise. Vous pouvez générer plusieurs clés pour différentes applications.",
  },

  // ==========================================
  // INTEGRATION
  // ==========================================
  integration: {
    delivery: {
      title: "Les entreprises de livraison",
      loading: "Chargement des entreprises de livraison...",
      subtitle: "Gestion des entreprises de livraison et de leurs intégrations API.",
      api_error: "Erreur de connexion API, affichage des données locales",
      refresh: "Actualiser",
      stats: "Total: {total} entreprise(s) • Actives: {active} • Inactives: {inactive}",
      data_may_be_outdated: "{error}. Les données affichées peuvent ne pas être à jour.",
      not_found: "Aucune entreprise trouvée",
      not_found_desc: "Aucune entreprise de livraison n'est actuellement configurée.",
      retry: "Réessayer",
      status_active: "Active",
      status_inactive: "Inactive",
      none: "Aucune",
      edit_info: "Modifier les informations",
      edit_info_for: "Modifier les informations pour {name}",
      active_status: "Statut actif",
      edit_hint: "Les modifications seront appliquées immédiatement.",
      connect: "Connecter",
      connect_to: "Connecter à",
      enter_creds: "Entrez les identifiants API",
      connect_hint: "Configurez les identifiants API pour activer l'intégration.",
      connecting: "Connexion...",
      client_id_label: "Client ID",
      token_label: "Token",
      key_label: "Clé",
      api_client_id: "API Client ID",
      api_token: "API Token",
      api_key: "API Key",
      api_secret_token: "API Secret/Token",
      placeholder_client_id: "Entrez le client ID",
      placeholder_api_key: "Entrez la clé API",
      placeholder_api_token: "Entrez le token API",
      update_success: "Entreprise mise à jour avec succès !",
      update_failed: "Échec de la mise à jour de l'entreprise",
      connect_success: "Connecté avec succès !",
      connect_failed: "Échec de la connexion. Veuillez vérifier vos identifiants.",
    },
    apps: {
      title: "Applications d'intégration",
      loading: "Chargement des applications d'intégration...",
      subtitle: "Gérez vos intégrations avec Shopify, YouCan et d'autres applications e-commerce.",
      api_error: "Erreur de connexion API, affichage des données locales",
      refresh: "Actualiser",
      stats: "Total: {total} application(s) • Actives: {active} • Inactives: {inactive}",
      data_may_be_outdated: "{error}. Les données affichées peuvent ne pas être à jour.",
      not_found: "Aucune application trouvée",
      not_found_desc: "Aucune application d'intégration n'est actuellement configurée.",
      retry: "Réessayer",
      status_connected: "Connecté",
      status_disconnected: "Déconnecté",
      store_label: "Boutique :",
      token_label: "Token :",
      none: "Aucune",
      shop_domain_label: "Domaine de la boutique",
      shop_domain_placeholder: "ex: ma-boutique.myshopify.com",
      shop_domain_hint: "Entrez le domaine de votre boutique e-commerce",
      connect: "Connecter",
      send_products: "Envoyer les produits",
      connect_woocommerce: "Connecter WooCommerce",
      step1_download_plugin: "1. Télécharger le plugin",
      step1_desc: "Téléchargez et installez notre plugin WordPress sur votre site WooCommerce.",
      download_plugin: "Télécharger le plugin",
      step2_configure_plugin: "2. Configurer le plugin",
      api_key: "Clé API",
      copy: "Copier",
      api_secret: "Secret API",
      webhook_endpoint: "Endpoint Webhook",
      error_http: "Erreur HTTP ! statut: {status}",
      error_fetch: "Échec de la récupération des intégrations.",
      done: "Terminé",
      products_selected: "{count} produit(s) sélectionné(s)",
      send_products_to: "Envoyer des produits vers",
      sku_hint: "Sélectionnez les produits à envoyer. Seuls les produits avec SKU seront synchronisés.",
      search_product_placeholder: "Rechercher des produits...",
      no_products_found: "Aucun produit trouvé",
      all_products_loaded: "Tous les produits sont chargés",
      disconnect_title: "Déconnecter l'application",
      disconnect_message: "Êtes-vous sûr de vouloir déconnecter cette application ?",
      landing_badge: "Recommandé par notre équipe",
      landing_title: "Générez votre landing page Shopify avec l'IA.",
      landing_desc: "Créez en quelques minutes une landing page professionnelle, optimisée pour la conversion, et connectez-la directement à votre boutique Shopify.",
      landing_feature_1: "Générateur de landing pages 100% Shopify",
      landing_feature_2: "Modèles prêts à l'emploi et optimisés conversion",
      landing_feature_3: "Sans code, installation en quelques clics",
      landing_cta: "Créer ma landing page Shopify",
      landing_note: "Outil externe — Webi Landing Page Builder",
    },
  },

  // ==========================================
  // VARIANTS (create form) - MERGED
  // ==========================================

  // ==========================================
  // VALIDATION ERRORS
  // ==========================================
  validation: {
    product_name_required: "Le nom du produit est requis.",
    achat_price_required: "Le prix d'achat est requis.",
    seller_price_required: "Le prix vendeur est requis.",
    selling_price_required: "Le prix de vente est requis.",
    stock_required: "La quantité en stock est requise.",
    category_required: "La catégorie est requise.",
    fournisseur_required: "Le fournisseur est requis.",
    primary_image_required: "Une image principale est requise.",
    price_logic: "Le prix d'achat doit être inférieur au prix de vente et au prix vendeur.",
    clients_required: "Au moins un client doit être sélectionné lorsque le produit n'est pas global.",
    discount_required: "La remise est requise.",
    discount_start_date_required: "La date de début de remise est requise.",
    discount_end_date_required: "La date de fin de remise est requise.",
    end_date_after_start: "La date de fin doit être postérieure à la date de début.",
    image_type: "Le fichier téléchargé doit être une image.",
    image_type_toast: "L'image principale doit être une image (PNG, JPG, GIF).",
    file_skipped: "Le fichier \"{fileName}\" n'est pas une image et a été ignoré.",
  },

  // ==========================================
  // ADMINS
  // ==========================================
  admins: {
    title_admin: "Profil Administrateur",
    title_assistant: "Profil Assistantes",
    subtitle: "Gestion des rôles administratifs",
    role_label: "Rôle :",
    access_level: "Niveau d'accès",
    edit_profile: "Modifier le Profil",
    saving: "Mise à jour...",
    personal_info: "Informations personnelles",
    full_name_label: "Nom complet *",
    name_placeholder: "Entrez le nom complet...",
    select_gender: "Sélectionnez le sexe",
    male: "Homme",
    female: "Femme",
    not_specified: "Non spécifié",
    phone_placeholder: "0612345678",
    admin_role_section: "Rôle administratif",
    no_role_available: "Aucun rôle disponible",
    no_specific_role: "Aucun rôle spécifique",
    validation: {
      email_required: "L'adresse e-mail est obligatoire.",
      email_valid: "L'adresse e-mail doit être valide.",
      name_required: "Le nom est obligatoire.",
      gender_required: "Le sexe est obligatoire.",
      phone_required: "Le numéro de téléphone est obligatoire.",
      phone_number: "Le numéro de téléphone doit être un nombre.",
      role_required: "Veuillez sélectionner un rôle spécifique pour l'assistant.",
    },
    success_update: "Utilisateur mis à jour avec succès !",
    errors: {
      form_errors: "Veuillez corriger les erreurs dans le formulaire.",
      update_failed: "Erreur de mise à jour de l'utilisateur !",
    },
    server_connection_failed: "Échec de la connexion au serveur",
    user_type_admin: "Admin",
    user_type_assistant: "Assistant",
    never: "Jamais",
    not_provided: "Non fourni",
    never_connected: "Jamais connecté",
    tooltip_never_connected: "Cet administrateur ne s'est jamais connecté",
    online_now: "En ligne",
    tooltip_online_now: "Cet administrateur est en ligne",
    online_day: "En ligne aujourd'hui",
    tooltip_yesterday: "Dernière connexion hier",
    inactive: "Inactif",
    tooltip_last_activity_month: "Dernière activité il y a plus d'un mois",
    online_min: "En ligne {minutes} min",
    tooltip_min_ago: "Connecté il y a {minutes} minute(s)",
    online_hours: "En ligne {hours}h",
    tooltip_hours_ago: "Connecté il y a {hours} heure(s)",
    online_days: "En ligne {days}j",
    tooltip_days_ago: "Connecté il y a {days} jour(s)",
    online_weeks: "En ligne {weeks}sem",
    tooltip_weeks_ago: "Connecté il y a {weeks} semaine(s)",
    phone_label: "Téléphone :",
    last_login_label: "Dernière connexion :",
    created_label: "Créé le :",
    page_title: "Gestion des administrateurs",
    page_subtitle: "Gérez les administrateurs et les assistantes et leur activité.",
    add: "Ajouter {type}",
    total: "Total {type}s",
    active_today: "Actif aujourd'hui",
    new_this_month: "Nouveau ce mois",
    search_placeholder: "Rechercher {type}s...",
    sort_name: "Alphabétique (Nom)",
    sort_email: "Alphabétique (Email)",
    sort_last_login: "Dernière connexion",
    sort_newest: "Plus récents d'abord",
    found_count: "{count} {type} trouvé(s)",
    no_results_title: "Aucun {type} trouvé",
    no_results_desc: "Essayez d'ajuster vos termes de recherche ou vos filtres.",
    add_first: "Ajouter votre premier {type}",
    load_error: "Échec du chargement des données utilisateur",
    error_fetch_msg: "Échec de la récupération des utilisateurs: {status}",
    error_unexpected_format: "Format de données inattendu reçu de l'API utilisateurs.",
    error_fetch_user: "Échec de la récupération des données utilisateur.",
    error_fetch_roles: "Échec de la récupération des rôles.",
  },

  // ==========================================
  // CONFIRMATORS
  // ==========================================
  confirmators: {
    title: "Profil Confirmateur",
    subtitle: "Gestion des confirmateurs",
    price_by_work: "Prix par travail",
    price_by_confirm: "Prix par confirmation",
    badge_title: "Confirm",
    specialized_role: "Rôle spécialisé",
    total_profit: "Total Profite",
    total_orders: "Total Commandes",
    confirmation_percentage: "Pourcentage confirmation",
    total_confirmed: "Total confirmé",
    total_sellers: "Total Vendeurs",
    edit_profile: "Modifier le Profil",
    saving: "Mise à jour...",
    personal_info: "Informations personnelles",
    full_name_label: "Nom complet *",
    name_placeholder: "Entrez le nom complet...",
    select_gender: "Sélectionnez le sexe",
    male: "Homme",
    female: "Femme",
    not_specified: "Non spécifié",
    phone_placeholder: "0612345678",
    rib_label: "Numéro RIB *",
    price_configuration: "Configuration des prix",
    active: "Actif",
    validation: {
      email_required: "L'adresse e-mail est obligatoire.",
      email_valid: "L'adresse e-mail doit être valide.",
      name_required: "Le nom est obligatoire.",
      gender_required: "Le sexe est obligatoire.",
      phone_required: "Le numéro de téléphone est obligatoire.",
      phone_number: "Le numéro de téléphone doit être un nombre.",
      rib_required: "Le RIB est obligatoire.",
      rib_number: "Le RIB doit être un nombre.",
      price_type_required: "Veuillez sélectionner un type de prix.",
      price_confirm_required: "Le tarif de confirmation est obligatoire.",
      price_confirm_positive: "Le tarif de confirmation doit être un nombre positif.",
      price_work_required: "Le tarif de travail est obligatoire.",
      price_work_positive: "Le tarif de travail doit être un nombre positif.",
    },
    success_update: "Confirmateur mis à jour avec succès !",
    errors: {
      form_errors: "Veuillez corriger les erreurs dans le formulaire.",
      update_failed: "Erreur de mise à jour du confirmateur !",
      unexpected: "Une erreur inattendue est survenue.",
      server_connection: "Échec de la connexion au serveur. Veuillez réessayer.",
    },
    no_name: "Aucun nom",
    no_phone: "Aucun téléphone",
    never_connected: "Jamais connecté",
    tooltip_never_connected: "Ce confirmateur ne s'est jamais connecté",
    online_now: "En ligne",
    tooltip_online_now: "Ce confirmateur est en ligne",
    online_day: "En ligne aujourd'hui",
    tooltip_yesterday: "Dernière connexion hier",
    inactive: "Inactif",
    tooltip_last_activity_month: "Dernière activité il y a plus d'un mois",
    online_min: "En ligne {minutes} min",
    tooltip_min_ago: "Connecté il y a {minutes} minute(s)",
    online_hours: "En ligne {hours}h",
    tooltip_hours_ago: "Connecté il y a {hours} heure(s)",
    online_days: "En ligne {days}j",
    tooltip_days_ago: "Connecté il y a {days} jour(s)",
    online_weeks: "En ligne {weeks}sem",
    tooltip_weeks_ago: "Connecté il y a {weeks} semaine(s)",
    confirmation_rate: "Taux de confirmation",
    per_month: "par mois",
    per_confirmation: "par confirmation",
    joined: "Membre depuis",
    page_title: "Gestion des confirmateurs",
    page_subtitle: "Gérez efficacement vos spécialistes de confirmation et suivez leurs performances.",
    add: "Ajouter un confirmateur",
    total: "Total confirmateurs",
    avg_rate: "Tarif moyen",
    highest_rate: "Tarif le plus élevé",
    new_this_month: "Nouveau ce mois",
    search_placeholder: "Rechercher des confirmateurs...",
    sort_name: "Alphabétique (Nom)",
    sort_email: "Alphabétique (Email)",
    sort_rate_high: "Tarif : élevé au bas",
    sort_rate_low: "Tarif : bas au élevé",
    found_count: "{count} confirmateur(s) trouvé(s)",
    no_results_title: "Aucun confirmateur trouvé",
    add_first: "Ajouter votre premier confirmateur",
    load_error: "Échec du chargement des données utilisateur",
    load_sellers_error: "Échec du chargement des données vendeurs",
    unexpected_format: "Format de données inattendu reçu de l'API confirmateurs.",
    loading_error: "Erreur lors du chargement des confirmateurs.",
    error_fetch_msg: "Échec de la récupération des confirmateurs: {status}",
    error_fetch_user: "Échec de la récupération des données du confirmateur.",
    error_fetch_sellers: "Échec de la récupération des vendeurs actifs.",
  },

  // ==========================================
  // BLACKLIST
  // ==========================================
  blacklist: {
    title: "Liste noire",
    subtitle: "Gérez la liste noire des clients, numéros ou adresses bloqués afin de prévenir les commandes à risque ou frauduleuses.",
    no_results: "Aucun résultat trouvé",
    empty: "Liste noire vide",
    no_results_desc: "Aucune entrée ne correspond à votre recherche.",
    empty_desc: "Commencez par ajouter des clients ou numéros à la liste noire.",
    blocked_on: "Bloqué le",
    unblock: "Débloquer",
    unblock_success: "Client débloqué avec succès",
    unblock_error: "Erreur lors du déblocage",
    unexpected_error: "Une erreur est survenue",
    unblock_modal_title: "Débloquer le client",
    unblock_modal_message: "Êtes-vous sûr de vouloir le retirer de la liste noire ?",
  },

  // ==========================================
  // CITIES
  // ==========================================
  cities: {
    title: "Villes",
    subtitle: "Gérez les villes de livraison et leurs frais de transport associés.",
    search_placeholder: "Rechercher des villes...",
    sort_delivery_low: "Prix livraison : croissant",
    sort_delivery_high: "Prix livraison : décroissant",
    sort_return_low: "Prix retour : croissant",
    sort_return_high: "Prix retour : décroissant",
    found_count: "{count} ville(s) trouvée(s)",
    page_info: "Page {page} sur {total}",
    no_results_title: "Aucune ville trouvée",
    shipping_fee: "Frais d'expédition",
    shipping: "Expédition",
    return: "Retour",
    refusal: "Refus",
    exchange: "Échange",
    error_fetch_msg: "Échec de la récupération des villes: {status}",
    error_unexpected_format: "Format de données inattendu reçu de l'API des villes.",
    error_loading: "Erreur lors du chargement des villes.",
  },

  // ==========================================
  // CONFIGS
  // ==========================================
  configs: {
    title: "Configuration du site",
    subtitle: "Gérez les informations de contact de votre site web et les liens des réseaux sociaux.",
    loading: "Chargement...",
    form_reset: "Le formulaire a été réinitialisé.",
    success_title: "Configuration mise à jour avec succès !",
    success_description: "Votre configuration a été mise à jour.",
    success_updated: "Configuration mise à jour avec succès !",
    sections: {
      contact_info: "Informations de contact",
      phone_numbers: "Numéros de téléphone",
      social_media: "Réseaux sociaux",
    },
    labels: {
      email: "Adresse e-mail",
      address: "Adresse",
      support_phone: "Téléphone du support",
      payment_phone: "Téléphone de paiement",
      stock_phone: "Téléphone du stock",
      exchange_phone: "Téléphone d'échange",
      facebook_url: "Lien Facebook",
      instagram_url: "Lien Instagram",
      telegram_url: "Lien Telegram",
    },
    placeholders: {
      email: "contact@example.com",
      address: "Entrez l'adresse...",
      facebook: "https://facebook.com/votrepage",
      instagram: "https://instagram.com/votrecompte",
      telegram: "https://t.me/votrecompte",
    },
    preview: {
      title: "Aperçu de la configuration",
      contact_info: "Informations de contact",
      specialized_phones: "Téléphones spécialisés",
      support: "Support",
      payment: "Paiement",
      stock: "Stock",
      exchange: "Échange",
      social_media: "Réseaux sociaux",
      no_social: "Aucun réseau social configuré.",
    },
    errors: {
      load_failed: "Erreur lors du chargement de la configuration.",
      email_invalid: "Veuillez entrer une adresse e-mail valide.",
      facebook_invalid: "Veuillez entrer un lien Facebook valide.",
      instagram_invalid: "Veuillez entrer un lien Instagram valide.",
      telegram_invalid: "Veuillez entrer un lien Telegram valide.",
      update_failed: "Échec de la mise à jour de la configuration.",
      generic_error: "Une erreur est survenue أثناء la mise à jour.",
    },
  },

  // ==========================================
  // FOURNISSEURS
  // ==========================================
  fournisseurs: {
    auth_required: "Authentification requise. Veuillez vous connecter.",
    supplier_name_label: "Nom du Fournisseur",
    supplier_name_placeholder: "Entrez le nom du fournisseur...",
    contact_person_label: "Nom du Contact",
    contact_person_placeholder: "Entrez le nom de la personne de contact...",
    email_label: "Email",
    email_placeholder: "Entrez l'adresse e-mail...",
    phone_label: "Téléphone",
    phone_placeholder: "Entrez le numéro de téléphone...",
    saving: "Enregistrement...",
    live_preview: "Aperçu en direct",
    contact: "Contact :",
    email_display: "Email :",
    phone_display: "Téléphone :",
    supplier_name_default: "Nom du Fournisseur",
    contact_person_default: "Personne de Contact",
    email_default: "Email",
    phone_default: "Téléphone",
    validation: {
      name_required: "Le nom du fournisseur est requis.",
      personnel_required: "Le nom du personnel est requis.",
      email_required: "L'adresse e-mail est requise.",
      email_valid: "Veuillez entrer une adresse e-mail valide.",
      phone_required: "Le numéro de téléphone est requis.",
      phone_valid: "Veuillez entrer un numéro de téléphone valide.",
    },
    errors: {
      form_errors: "Veuillez corriger les erreurs dans le formulaire.",
      create_failed: "Échec de la création du fournisseur.",
      create_failed_short: "Échec de la création.",
      highlighted_fields: "Veuillez corriger les champs mis en évidence.",
      network_error: "Une erreur réseau inattendue est survenue. Veuillez vérifier votre connexion.",
      unexpected: "Une erreur inattendue est survenue. Veuillez réessayer.",
      unexpected_short: "Erreur inattendue.",
    },
    success_created: "Fournisseur créé avec succès !",
    success_description: "Le nouveau fournisseur a été ajouté au système.",
    success_update: "Fournisseur mis à jour avec succès !",
    title: "Fournisseurs",
    subtitle: "Gérez vos fournisseurs, leurs informations de contact et leurs détails.",
    add: "Ajouter un Fournisseur",
    search_placeholder: "Rechercher des fournisseurs...",
    sort_name: "Nom",
    sort_contact: "Nom du contact",
    sort_newest: "Plus récent",
    sort_oldest: "Plus ancien",
    fournisseur_singular: "fournisseur",
    fournisseur_plural: "fournisseurs",
    found: "trouvé(s)",
    not_found: "Aucun fournisseur trouvé",
    not_found_desc: "Essayez d'ajuster vos termes de recherche ou vos filtres pour trouver ce que vous cherchez.",
    create_first: "Créer votre premier fournisseur",
    create_title: "Create un fournisseur",
    create_subtitle: "Add a new fournisseur option for your products. Define colors, sizes, materials, or any other attribute.",
    update_title: "Modifier le Fournisseur",
    update_subtitle: "Modifiez les détails de ce fournisseur spécifique.",
    id_missing: "L'ID du fournisseur est manquant.",
    fetch_failed: "Échec de la récupération du fournisseur",
    fetch_error: "Une erreur inattendue est survenue lors de la récupération du fournisseur.",
    load_failed: "Échec du chargement du fournisseur.",
    error_loading: "Erreur lors du chargement du fournisseur",
    not_found_id: "Fournisseur Introuvable",
    not_found_id_desc: "Le fournisseur avec l'ID \"{id}\" n'a pas pu être chargé ou n'existe pas.",
    delete_title: "Supprimer le fournisseur",
    delete_message: "Êtes-vous sûr de vouloir supprimer ce fournisseur ?",
    error_fetch_msg: "Échec de la récupération des fournisseurs: {status}",
    error_unexpected_format: "Format de données inattendu reçu de l'API des fournisseurs.",
  },

  // ==========================================
  // PERMISSION GROUPS (used in roles create/edit form)
  // ==========================================
  permission_groups: {
    product_management: "Gestion des produits",
    product_management_desc: "Voir et gérer les produits",
    category_management: "Gestion des catégories",
    category_management_desc: "Gérer les catégories de produits",
    variant_management: "Gestion des variantes",
    variant_management_desc: "Gérer les variantes de produits",
    supplier_management: "Gestion des fournisseurs",
    supplier_management_desc: "Gérer les fournisseurs",
    order_management: "Gestion des commandes",
    order_management_desc: "Gérer les commandes et livraisons clients",
    confirmator_management: "Gestion des confirmateurs",
    confirmator_management_desc: "Gérer les confirmateurs de commandes",
    seller_management: "Gestion des vendeurs",
    seller_management_desc: "Gérer les comptes vendeurs",
    confirmator_invoices: "Factures des confirmateurs",
    confirmator_invoices_desc: "Gérer les factures et paiements des confirmateurs",
    seller_invoices: "Factures des vendeurs",
    seller_invoices_desc: "Gérer les factures et paiements des vendeurs",
    statistics: "Statistiques",
    statistics_desc: "Voir les statistiques et rapports système",
    announcement_management: "Gestion des annonces",
    announcement_management_desc: "Gérer les annonces système",
    reclamation_management: "Gestion des réclamations",
    reclamation_management_desc: "Gérer les réclamations et retours clients",
    system_configuration: "Configuration système",
    system_configuration_desc: "Modifier les paramètres système",
    blacklist_management: "Gestion de la liste noire",
    blacklist_management_desc: "Gérer les utilisateurs ou entités sur liste noire",
  },

  // ==========================================
  // LIVREURS
  // ==========================================
  livreurs: {
    auth_required: "Authentification requise. Veuillez vous connecter.",
    subtitle: "Gestion des livreurs",
    badge_title: "Livreur",
    trust_score: "Score de confiance",
    total_delivered: "Total Livré",
    unit_price: "Prix Unitaire",
    total_earnings: "Gains Totaux Estimés",
    personal_info: "Informations personnelles",
    delivery_person_label: "Nom du Livreur",
    name_placeholder: "Entrez le nom du livreur...",
    email_label: "Email",
    email_placeholder: "Entrez l'email du livreur...",
    phone_label: "Téléphone",
    phone_placeholder: "Entrez le numéro de téléphone...",
    delivery_payment_details: "Détails de Livraison & paiement",
    delivery_price_label: "Prix de livraison (DH)",
    delivery_price_placeholder: "Entrez le prix de livraison...",
    rib_label: "RIB (Optionnel)",
    rib_placeholder: "Entrez le RIB...",
    saving: "Enregistrement...",
    recent_activity: "Activité Récente",
    order: "Commande",
    action_date: "Date de l'action",
    delivery_price_header: "Prix Livraison",
    status: "Statut",
    total: "Total",
    validation: {
      name_required: "Le nom du livreur est requis.",
      email_required: "L'email est requis.",
      email_valid: "L'email n'est pas valide.",
      phone_required: "Le numéro de téléphone est requis.",
      phone_valid: "Veuillez entrer un numéro de téléphone valide.",
      delivery_price_required: "Le prix de livraison est requis.",
      delivery_price_number: "Le prix de livraison doit être un nombre.",
    },
    errors: {
      form_errors: "Veuillez corriger les erreurs dans le formulaire.",
      highlighted_fields: "Veuillez corriger les champs mis en évidence.",
      network_error: "Une erreur réseau inattendue est survenue. Veuillez vérifier votre connexion.",
      unexpected: "Une erreur inattendue est survenue. Veuillez réessayer.",
    },
    success_update: "Livreur mis à jour avec succès !",
    title: "Livreurs",
    list_subtitle: "Gérez vos livreurs, leurs informations de contact et leurs tarifs.",
    add: "Ajouter un Livreur",
    search_placeholder: "Rechercher des livreurs...",
    sort_name: "Nom",
    sort_newest: "Plus récent",
    sort_oldest: "Plus ancien",
    sort_price_asc: "Prix Croissant",
    sort_price_desc: "Prix Décroissant",
    livreur_singular: "livreur",
    livreur_plural: "livreurs",
    found: "trouvé(s)",
    not_found: "Aucun livreur trouvé",
    not_found_desc: "Essayez d'ajuster vos termes de recherche ou vos filtres.",
    create_first: "Créer votre premier livreur",
    id_missing: "L'ID du livreur est manquant.",
    fetch_failed: "Échec de la récupération du livreur",
    fetch_error: "Une erreur inattendue est survenue lors de la récupération du livreur.",
    load_failed: "Échec du chargement du livreur.",
    error_loading: "Erreur lors du chargement du livreur",
    not_found_id: "Livreur Introuvable",
    not_found_id_desc: "Le livreur avec l'ID \"{id}\" n'a pas pu être chargé ou n'existe pas.",
    delete_title: "Supprimer le livreur",
    delete_message: "Êtes-vous sûr de vouloir supprimer ce livreur ?",
    error_fetch_msg: "Échec de la récupération des livreurs: {status}",
    error_unexpected_format: "Format de données inattendu reçu de l'API des livreurs.",
  },

  // ==========================================
  // ROLES
  // ==========================================
  roles: {
    role_name_label: "Nom du rôle *",
    role_name_placeholder: "ex: Administrateur, Éditeur, Gestionnaire Produits",
    success_update: "Rôle modifié avec succès !",
    updated_with_permissions: "Le rôle a été mis à jour avec les permissions sélectionnées.",
    assign_permissions: "Attribuer les permissions",
    assign_permissions_desc: "Sélectionnez les actions spécifiques que ce rôle pourra effectuer.",
    select_all: "Tout",
    select_none: "Aucun",
    saving: "Mise à jour...",
    update: "Mettre à jour",
    role_preview: "Aperçu du rôle",
    role_name_default: "Nom du rôle",
    permissions_label: "Permissions :",
    permissions_total: "permissions au total",
    no_permissions_selected: "Aucune permission sélectionnée",
    and_others: "et",
    others: "autres",
    errors: {
      update_failed: "Erreur lors de la modification du rôle",
    },
    validation: {
      name_required: "Le nom du rôle est requis",
    },
    active_permissions: "Permissions actives",
    no_permissions: "Aucune permission",
    delete_title: "Supprimer le rôle",
    delete_message: "Êtes-vous sûr de vouloir supprimer ce rôle ?",
    permissions: {
      product_management: "Gestion des produits",
      product_management_desc: "Voir et gérer les produits",
      category_management: "Gestion des catégories",
      category_management_desc: "Gérer les catégories de produits",
      variant_management: "Gestion des variantes",
      variant_management_desc: "Gérer les variantes de produits",
      supplier_management: "Gestion des fournisseurs",
      supplier_management_desc: "Gérer les fournisseurs",
      order_management: "Gestion des commandes",
      order_management_desc: "Gérer les commandes et livraisons clients",
      confirmator_management: "Gestion des confirmateurs",
      confirmator_management_desc: "Gérer les confirmateurs de commandes",
      seller_management: "Gestion des vendeurs",
      seller_management_desc: "Gérer les comptes vendeurs",
      confirmator_invoices: "Factures des confirmateurs",
      confirmator_invoices_desc: "Gérer les factures et paiements des confirmateurs",
      seller_invoices: "Factures des vendeurs",
      seller_invoices_desc: "Gérer les factures et paiements des vendeurs",
      statistics: "Statistiques",
      statistics_desc: "Voir les statistiques et rapports système",
      announcement_management: "Gestion des annonces",
      announcement_management_desc: "Gérer les annonces système",
      reclamation_management: "Gestion des réclamations",
      reclamation_management_desc: "Gérer les réclamations et retours clients",
      system_configuration: "Configuration système",
      system_configuration_desc: "Modifier les paramètres système",
      blacklist_management: "Gestion de la liste noire",
      blacklist_management_desc: "Gérer les utilisateurs ou entités sur liste noire",
    },
    permission_labels: {
      view_products: "Voir les produits",
      add_product: "Ajouter un produit",
      edit_product: "Modifier un produit",
      delete_product: "Supprimer un produit",
      view_categories: "Voir les catégories",
      add_category: "Ajouter une catégorie",
      edit_category: "Modifier une catégorie",
      delete_category: "Supprimer une catégorie",
      view_variants: "Voir les variantes",
      add_variant: "Ajouter une variante",
      edit_variant: "Modifier une variante",
      delete_variant: "Supprimer une variante",
      view_fournisseurs: "Voir les fournisseurs",
      add_fournisseur: "Ajouter un fournisseur",
      edit_fournisseur: "Modifier un fournisseur",
      delete_fournisseur: "Supprimer un fournisseur",
      view_orders: "Voir les commandes",
      update_order: "Modifier une commande",
      delete_order: "Supprimer une commande",
      scan_order: "Scanner une commande",
      send_delivery: "Envoyer en livraison",
      view_confirmator: "Voir les confirmateurs",
      add_confirmator: "Ajouter un confirmateur",
      edit_confirmator: "Modifier un confirmateur",
      delete_confirmator: "Supprimer un confirmateur",
      change_confirmator_password: "Changer le mot de passe du confirmateur",
      view_saller: "Voir les vendeurs",
      add_saller: "Ajouter un vendeur",
      edit_saller: "Modifier un vendeur",
      delete_saller: "Supprimer un vendeur",
      change_saller_password: "Changer le mot de passe du vendeur",
      update_saller_status: "Mettre à jour le statut du vendeur",
      view_confirmator_invoices: "Voir les factures des confirmateurs",
      generate_confirmator_invoices: "Générer les factures des confirmateurs",
      pay_confirmator_invoices: "Payer les factures des confirmateurs",
      delete_confirmator_invoices: "Supprimer les factures des confirmateurs",
      view_saller_invoices: "Voir les factures des vendeurs",
      generate_saller_invoices: "Générer les factures des vendeurs",
      pay_saller_invoices: "Payer les factures des vendeurs",
      delete_saller_invoices: "Supprimer les factures des vendeurs",
      view_statistics: "Voir les statistiques",
      view_annonces: "Voir les annonces",
      add_annonce: "Ajouter une annonce",
      edit_annonce: "Modifier une annonce",
      delete_annonce: "Supprimer une annonce",
      view_reclamations: "Voir les réclamations",
      reply_reclamation: "Répondre aux réclamations",
      delete_reclamation: "Supprimer une réclamation",
      edit_config: "Modifier la configuration",
      view_blacklist: "Voir la liste noire",
      add_blacklist: "Ajouter à la liste noire",
      remove_blacklist: "Retirer de la liste noire",
    },
  },

  // ==========================================
  // CART
  // ==========================================
  cart: {
    your_cart: "Votre Panier",
    check_items: "Vérifiez vos articles et finalisez votre achat",
    items_in_cart: "Articles dans le panier ({count})",
    cart_empty: "Votre panier est vide.",
    selling_price_label: "Prix de vente",
    selling_price_placeholder: "Entrez le prix de vente...",
    reduce_quantity: "Réduire la quantité",
    increase_quantity: "Augmenter la quantité",
    remove_item: "Supprimer l'article",
    order_summary: "Résumé de la commande",
    subtotal_with_items: "Sous-total ({count} articles)",
    shipping: "Expédition",
    estimated_profit: "Bénéfice estimé",
    total_client: "Total client",
    total_client_colon: "Total Client :",
    estimated_profit_colon: "Profit estimé :",
    secure_payment: "Paiement sécurisé",
    free_returns: "Retours gratuits",
    checkout_details: "Détails de la caisse",
    name_label: "Nom",
    name_placeholder: "Entrez le nom...",
    phone_label: "Numéro de Téléphone",
    phone_placeholder: "Entrez le numéro de téléphone...",
    city_label: "Ville",
    loading_cities: "Chargement des villes...",
    choose_city: "Choisissez une ville...",
    no_cities_found: "Aucune ville trouvée",
    address_label: "Adresse",
    address_placeholder: "Entrez l'adresse...",
    change: "Change",
    unlockable: "L'ouverture de colis",
    already_confirmed: "Déjà confirmé",
    comment_label: "Commentaire",
    comment_placeholder: "Entrez le commentaire...",
    submitting: "Soumission...",
    place_order: "Passer la commande",
    fill_required_fields: "Veuillez remplir tous les champs obligatoires.",
    cart_empty_order: "Votre panier est vide. Ajoutez des articles pour passer commande.",
    check_selling_prices: "Veuillez vérifier les prix de vente de tous les articles.",
    order_submitted: "Commande soumise avec succès !",
    order_submit_error: "Erreur lors de la soumission de la commande.",
    error_loading_cities: "Erreur lors du chargement des villes.",
    parse_cart_error: "Erreur lors de l'analyse du panier.",
    items_label: "articles",
  },

  // ==========================================
  // PROFILE
  // ==========================================
  profile: {
    admin: {
      title_admin: "Admin",
      title_assistant: "Assistant",
      role_admin_desc: "System Administrator",
      role_assistant_desc: "System Assistant",
      trust_score: "Score de confiance",
      edit: "Modifier le Profil",
      saving: "Mise à jour...",
      save: "Enregistrer",
      cancel: "Annuler",
      personal_info: "Informations personnelles",
      account_settings: "Account Settings",
      full_name: "Full Name",
      gender: "Gender",
      email: "Email",
      phone: "Phone",
      not_specified: "Non spécifié",
      male: "Male",
      female: "Female",
      update_success: "Utilisateur mis à jour avec succès !",
      update_error: "Erreur de mise à jour les donné !",
      connection_error: "Erreur de connexion",
    },
    seller: {
      personal_info: "Informations personnelles",
      edit_profile: "Modifier le profil",
      saving: "Mise à jour...",
      save: "Enregistrer",
      cancel: "Annuler",
      loading: "Chargement des données utilisateur...",
      full_name: "Nom complet",
      store_name: "Nom du magasin",
      bank_name: "Nom de la banque",
      rib: "RIB",
      logo: "Logo du magasin (Optionnel)",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      seller_level: "Niveau du vendeur",
      not_specified: "Non spécifié",
      current_logo: "Logo actuel",
      no_logo: "Aucun logo téléchargé",
      delete_logo_aria: "Supprimer le logo",
      level_prefix: "Niveau",
      level_badge: "Vendeur Niveau",
      update_success: "Profil mis à jour avec succès !",
      update_error: "Échec de la mise à jour du profil",
      validation_error: "Veuillez corriger les erreurs dans le formulaire",
      server_error: "Erreur de validation",
      name_error: "Le nom doit contenir au moins 2 caractères",
      store_name_error: "Le nom du magasin doit contenir au moins 2 caractères",
      bank_error: "Veuillez sélectionner une banque",
      rib_error: "Le RIB doit contenir au moins 10 caractères",
      address_error: "L'adresse doit contenir au moins 5 caractères",
      phone_error: "Veuillez entrer un numéro de téléphone valide",
      email_error: "Veuillez entrer une adresse email valide",
      image_type_error: "Veuillez sélectionner un fichier image",
      image_size_error: "La taille de l'image doit être inférieure à 5 Mo",
      store_alt: "Logo du magasin",
      level_beginner: "Débutant",
      level_intermediate: "Intermédiaire",
      level_advanced: "Avancé",
    },
    confirmator: {
      title: "Profil Confirimateur",
      subtitle: "Confirimateur de commandes",
      badge: "Confirimateur",
      trust_score: "Score de confiance",
      edit: "Modifier le profil",
      saving: "Mise à jour...",
      save: "Enregistrer",
      cancel: "Annuler",
      full_name: "Nom complet",
      gender: "Genre",
      rib: "Compte bancaire (RIB)",
      email: "Email",
      phone: "Téléphone",
      not_specified: "Non spécifié",
      male: "Homme",
      female: "Femme",
      not_available: "Non disponible",
      update_success: "Profil mis à jour avec succès !",
      update_error: "Erreur lors de la mise à jour du profil !",
      validation_error: "Veuillez corriger les erreurs dans le formulaire !",
      loading: "Chargement des données utilisateur...",
      validation_phone: "Le numéro de téléphone doit être une chaîne de caractères",
      validation_email: "L'adresse email n'est pas valide",
      validation_name: "Le nom doit contenir au moins 2 caractères",
    },
    livreur: {
      title: "Profil Livreur",
      badge: "Livreur",
      delivery_price_label: "Prix de livraison",
      edit: "Modifier le profil",
      saving: "Mise à jour...",
      save: "Enregistrer",
      cancel: "Annuler",
      full_name: "Nom complet",
      phone: "Téléphone",
      email: "Email",
      rib: "RIB (Optionnel)",
      delivery_price: "Prix de livraison (DH)",
      not_specified: "Non spécifié",
      loading: "Chargement des données utilisateur...",
      not_found: "Profil livreur introuvable.",
      update_success: "Profil mis à jour avec succès !",
      update_error: "Échec de la mise à jour du profil",
      validation_error: "Veuillez corriger les erreurs dans le formulaire",
      server_error: "Erreur de validation",
      info_not_found: "Informations du livreur non trouvées",
      name_error: "Le nom doit contenir au moins 2 caractères",
      email_error: "Veuillez entrer une adresse email valide",
      phone_error: "Veuillez entrer un numéro de téléphone valide",
      rib_error: "Le RIB doit contenir au moins 10 caractères",
    },
  },

  // ==========================================
  // USERS CREATE
  // ==========================================
  users: {
    success_created: "Utilisateur créé avec succès !",
    success_description: "Le nouvel utilisateur a été ajouté au système.",
    server_error: "Une erreur inattendue s'est produite.",
    server_connection_failed: "Échec de la connexion au serveur. Veuillez réessayer.",
    no_permission: "Vous n'avez pas les permissions nécessaires !",
    create_error: "Erreur lors de la création de l'utilisateur !",
    correct_form_errors: "Veuillez corriger les erreurs dans le formulaire.",
    no_store: "Pas de boutique",
    no_sellers_found: "Aucun vendeur trouvé",
    create_user: "Créer l'utilisateur",
    saving: "Enregistrement...",
    create_title: "Créer un nouvel utilisateur",
    create_subtitle: "Ajoutez un nouvel utilisateur au système avec des accès basés sur les rôles et des informations supplémentaires.",
    error_fetch: "Error: {error}",
    no_token: "No authentication token found",
    failed_roles: "Failed to fetch roles",
    failed_sellers: "Failed to fetch sellers",
    role_admin: "Admin",
    role_assistant: "Assistant",
    role_confirmator: "Confirmateur",
    role_livreur: "Livreur",
    sections: {
      livreur_info: "Informations du livreur",
      confirmator_info: "Informations du confirmateur",
      assigned_sellers: "Vendeurs assignés",
      assigned_sellers_desc: "Sélectionnez les vendeurs avec lesquels ce confirmateur peut travailler :",
    },
    labels: {
      confirmator_price: "Prix *",
      price_by_confirm: "Prix par confirmation *",
      price_by_work: "Prix par travail *",
    },
    placeholders: {
      email: "user@example.com",
      password: "Entrez le mot de passe...",
      confirm_password: "Confirmez le mot de passe...",
      rib: "12345678901234567890",
      confirmator_price: "25.00",
      work_price: "500.00",
      delivery_price: "20.00",
      select_sellers: "Rechercher et sélectionner des vendeurs...",
    },
    validation: {
      email_required: "L'adresse e-mail est requise.",
      email_valid: "L'e-mail doit être valide.",
      password_required: "Le mot de passe est requis.",
      password_min_length: "Le mot de passe doit contenir au moins 6 caractères.",
      password_mismatch: "Les mots de passe ne correspondent pas.",
      role_required: "Le rôle est requis.",
      role_invalid: "Le rôle doit être 1 (Admin), 2 (Assistant), 3 (Confirmateur) ou 4 (Livreur).",
      name_required: "Le nom est requis.",
      gender_required: "Le genre est requis.",
      phone_required: "Le numéro de téléphone est requis.",
      phone_number: "Le numéro de téléphone doit être numérique.",
      no_assistant_roles: "Aucun rôle d'assistant disponible. Veuillez contacter l'administrateur.",
      select_assistant_role: "Veuillez sélectionner un rôle spécifique pour l'assistant.",
      rib_required: "Le RIB est requis pour le rôle 3.",
      rib_number: "Le RIB doit être un nombre.",
      price_type_required: "Veuillez choisir un type de prix (par confirmation ou par travail).",
      confirm_price_required: "Le prix de confirmation est requis.",
      confirm_price_positive: "Le prix de confirmation doit être un nombre positif.",
      work_price_required: "Le prix du travail est requis.",
      work_price_positive: "Le prix du travail doit être un nombre positif.",
      livreur_price_required: "Le prix de livraison est requis.",
      livreur_price_number: "Le prix doit être un nombre.",
    },
  },

  // ==========================================
  // ROLES
  // ==========================================
  roles_page: {
    title: "Roles Management",
    subtitle: "Define and manage granular permissions for different roles in your application.",
    add_new: "Add New Role",
    search_placeholder: "Search roles by name...",
    filter: "Filter",
    sort_name: "Name",
    sort_newest: "Newest",
    sort_oldest: "Oldest",
    sort_permissions: "Number of Permissions",
    role_found_singular: "role found",
    role_found_plural: "roles found",
    no_roles_found: "No roles found",
    no_roles_desc: "Try adjusting your search terms or filters, or create a new role.",
    create_first: "Create Your First Role",
    create_title: "Add New Role Assistans",
    create_subtitle: "Add a new role to your delivery network with associated shipping costs.",
    update_title: "Modifier le rôle",
    update_subtitle: "Modifiez les détails de cette rôle spécifique.",
    update_error_id: "L'ID de la role est manquant.",
    update_not_authenticated: "Vous n'êtes pas authentifié. Veuillez vous connecter.",
    update_auth_error: "Jeton d'authentification introuvable. Veuillez vous connecter.",
    update_invalid_format: "Format de données invalide de l'API.",
    update_fetch_error: "Une erreur inattendue est survenue lors de la récupération de le role.",
    update_load_error: "Échec du chargement de le role.",
    update_load_title: "Erreur lors du chargement de la catégorie",
    update_retry: "Réessayer",
    update_not_found_title: "Catégorie Introuvable",
    update_not_found_desc: "La catégorie avec l'ID \"{id}\" n'a pas pu être chargée ou n'existe pas.",
    update_data_format_error: "Invalid data format received from the server.",
    update_api_format_error: "Received unexpected data format from roles API.",
    update_loading_error: "Error loading roles.",
  },

  // ==========================================
  // VARIANTS (update form)
  // ==========================================
  variants: {
    create_title: "Créer une nouvelle variante",
    create_subtitle: "Ajoutez une nouvelle option de variante pour vos produits. Définissez des couleurs, des tailles, des matériaux ou tout autre attribut.",
    update_title: "Modifier la variante",
    update_subtitle: "Modifiez les détails de cette variante.",
    id_missing: "L'ID de la variante est manquant.",
    fetch_failed: "Échec de la récupération de la variante",
    unexpected_format: "Format de données inattendu de l'API variantes.",
    error_loading: "Erreur lors du chargement de la variante",
    error_loading_title: "Erreur lors du chargement de la variante",
    not_found: "Variante introuvable",
    not_found_desc: "La variante avec l'ID \"{id}\" n'a pas pu être chargée ou n'existe pas.",
    error_prefix: "Erreur :",
    variant_product: "Produit à variantes",
    available_all_clients: "Disponible pour tous les clients par défaut",
    dimensions: "Dimensions des variantes",
    color: "Couleur",
    size: "Taille",
    choose_dimensions_hint: "Choisissez Couleur seulement, Taille seulement, ou les deux. Chaque option sélectionnée est une variante vendable ; toutes les lignes utilisent les mêmes dimensions.",
    add_color_size_hint: "Ajoutez au moins une couleur et une taille dans les paramètres de variantes pour utiliser la grille Couleur × Taille.",
    color_size_header: "Couleur / Taille",
    color_header: "Couleur",
    size_header: "Taille",
    include_header: "Inclure",
    no_colors_defined: "Aucune couleur définie dans les paramètres de variantes.",
    no_sizes_defined: "Aucune taille définie dans les paramètres de variantes.",
    error_select_types: "Sélectionnez Couleur et/ou Taille pour les variantes.",
    error_select_one: "Sélectionnez au moins une option de variante.",
    list_title: "Variantes",
    list_subtitle: "Gérez les variantes de produits, y compris les couleurs, les tailles, les matériaux et d'autres attributs.",
    add_variant: "Ajouter une variante",
    search_placeholder: "Rechercher des variantes...",
    filter_by_type: "Filtrer par type",
    all_types: "Tous les types",
    sort_type: "Type",
    found_count: "{count} variante trouvée",
    found_count_plural: "{count} variantes trouvées",
    no_variants_found: "Aucune variante trouvée",
    no_results_desc: "Essayez d'ajuster vos termes de recherche ou vos filtres pour trouver ce que vous cherchez.",
    create_first: "Créer votre première variante",
    auth_required: "Authentification requise. Veuillez vous connecter.",
    warning: "Avertissement : si vous modifiez une variante, cela changera dans toutes les anciennes commandes !",
    variant_type_label: "Type de variante *",
    type_color: "Couleur",
    type_size: "Taille",
    type_material: "Matière",
    type_other: "Autre",
    variant_name_label: "Nom de la variante *",
    name_placeholder: "ex: Petit, Bleu, Coton",
    variant_value_label: "Valeur de la variante *",
    value_label: "Valeur",
    color_placeholder: "var(--color-primary-500) ou rouge",
    choose_predefined_colors: "Ou choisissez parmi les couleurs prédéfinies :",
    value_placeholder: "Entrez la valeur...",
    saving: "Enregistrement...",
    save_changes: "Enregistrer les modifications",
    live_preview: "Aperçu en direct",
    no_value: "Aucune valeur",
    variant_name_default: "Nom de la variante",
    selected_color: "Couleur sélectionnée",
    select_color: "Sélectionnez la couleur",
    preview_color: "Aperçu de la couleur",
    success_update: "Variante mise à jour avec succès !",
    success_created: "Variante créée avec succès !",
    success_description: "La nouvelle variante a été ajoutée au système.",
    validation: {
      name_required: "Le nom de la variante est requis.",
      value_required: "La valeur de la variante est requise.",
      color_invalid: "Veuillez entrer un code couleur hexadécimal valide (ex: var(--color-primary-500)).",
    },
    errors: {
      highlighted_fields: "Veuillez corriger les champs mis en évidence.",
      network_error: "Une erreur réseau inattendue est survenue. Veuillez vérifier votre connexion.",
      unexpected: "Une erreur inattendue est survenue. Veuillez réessayer.",
      create_failed: "Échec de la création de la variante. Veuillez réessayer.",
    },
    delete_title: "Supprimer la variante",
    delete_message: "Êtes-vous sûr de vouloir supprimer cette variante ?",
  },
  // ==========================================
  // SCAN RETURN
  // ==========================================
  scan: {
    scanner_title_ramassage: "Scanner les Commandes Pré a ramassé",
    scanner_title_retour: "Scanner les Commandes Retourné",
    scanner_description: "Scannez le code-barres pour marquer comme \"Retour reçu\"",
    scanner_description_ramassage: "Scannez le code-barres pour marquer comme \"Pré a ramassé\"",
    scanning: "Scan en cours...",
    press_enter: "Appuyez sur Entrée pour scanner",
    already_scanned: "Commande déjà scannée",
    scan_success: "Commande scannée avec succès",
    current_status: "Statut actuel :",
    scanned_on: "Scanné le",
    scanned_order: "Commande scannée",
    client: "Client",
    delivery: "Livraison",
    vendor: "Vendeur",
    products: "Produits",
    total: "Total :",
    per_unit: "DH/unité",
    status_history: "Historique des Statuts",
    reason: "Raison :",
    postponed_to: "Reporté au :",
    comment: "Commentaire :",
    history_title: "Historique des Scans",
    history_cleared: "Historique effacé",
    history_subtitle: "commande(s) scannée(s)",
    marked_as_received: "retour(s) reçu(s)",
    no_scans: "Aucun scan pour le moment",
    no_scans_desc: "Scannez une commande pour commencer",
    rescan: "Rescanner",
    code_copied: "Code copié",
    copy_code: "Copier code",
    clear: "Effacer",
    not_found: "Commande non trouvée",
    scan_error: "Erreur de scan",
    marked_return: "Commande {code} marquée comme retour reçu",
    marked_pre_a_ramasse: "Commande {code} marquée comme Pré a ramassé",
  },

  // ==========================================
  // AUTH
  // ==========================================
  auth: {
    my_platform: "Ma Plateforme",
    welcome_back: "Bon retour !",
    login_subtitle: "Connectez-vous à votre compte pour continuer",
    email_label: "Adresse e-mail",
    email_placeholder: "Entrez votre adresse e-mail",
    password_label: "Mot de passe",
    password_placeholder: "Entrez votre mot de passe",
    confirm_password_label: "Confirmer le mot de passe",
    confirm_password_placeholder: "Confirmez le mot de passe",
    remember_me: "Se souvenir de moi",
    forgot_password: "Mot de passe oublié ?",
    login_button: "Se connecter",
    no_account: "Vous n'avez pas de compte ?",
    create_account_link: "Créez un compte",
    login_error: "Erreur de connexion",
    server_error: "Échec de la connexion au serveur",
    register_title: "Créer un nouveau compte",
    register_step: "Étape {step} sur 2",
    step1_title: "Informations du compte",
    step2_title: "Détails du vendeur",
    account_info_title: "Informations du compte",
    seller_info_title: "Informations du vendeur",
    full_name_label: "Nom complet",
    full_name_placeholder: "Entrez votre nom complet",
    store_name_label: "Nom du magasin (Optionnel)",
    store_name_placeholder: "Entrez le nom du magasin (si applicable)",
    bank_name_label: "Nom de la banque",
    rib_label: "RIB (Numéro de compte bancaire)",
    rib_placeholder: "Entrez votre RIB",
    address_label: "Adresse",
    address_placeholder: "Entrez votre adresse complète",
    phone_label: "Numéro de téléphone",
    phone_placeholder: "Entrez votre numéro de téléphone",
    seller_level_label: "Niveau du vendeur",
    seller_level_placeholder: "Choisissez le niveau",
    level_beginner: "Débutant",
    level_intermediate: "Intermédiaire",
    level_advanced: "Avancé",
    store_logo_label: "Logo du magasin (Optionnel)",
    next_button: "Suivant",
    back_button: "Retour",
    submit_button: "Créer le compte",
    has_account: "Vous avez déjà un compte ?",
    login_link_text: "Se connecter",
    register_success: "Compte créé avec succès !",
    register_success_desc: "Votre compte et vos informations de vendeur ont été créés avec succès ! Vous allez être redirigé vers la page de connexion.",
    register_creation_failed: "Échec de la création du compte de base.",
    register_validation_failed: "Veuillez corriger les erreurs d'inscription",
    name_required: "Le nom complet est requis",
    email_required: "L'adresse e-mail est requise.",
    email_invalid: "Le format de l'adresse e-mail n'est pas valide.",
    password_required: "Le mot de passe est requis.",
    password_min_length: "Le mot de passe doit contenir au moins 6 caractères.",
    confirm_password_required: "La confirmation du mot de passe est requise.",
    password_mismatch: "Les mots de passe ne correspondent pas.",
    bank_required: "Le nom de la banque est requis.",
    rib_required: "Le RIB est requis.",
    address_required: "L'adresse est requise.",
    phone_required: "Le numéro de téléphone est requis.",
    level_required: "Le niveau du vendeur est requis.",
    show_password: "Afficher le mot de passe",
    hide_password: "Masquer le mot de passe",
    terms_and_conditions: "Conditions générales",
    bank_placeholder: "Choisissez la banque",
    today_earnings: "Gains du jour",
    products_sold: "+ 38 produits vendus",
    weekly_growth: "Croissance cette semaine",
    total_revenue: "Revenu total",
    total_products: "Produits totaux",
    commissions: "Commissions",
    this_week: "Cette semaine",
    reset_back_to_login: "Retour à la connexion",
    reset_forgot_title: "Mot de passe oublié",
    reset_forgot_subtitle: "Entrez votre adresse e-mail et nous vous enverrons un code de réinitialisation",
    reset_send_code: "Envoyer le code",
    reset_code_title: "Vérifier le code",
    reset_code_sent_to: "Un code a été envoyé à",
    reset_code_label: "Code de vérification (6 chiffres)",
    reset_verify_button: "Vérifier le code",
    reset_code_invalid: "Code incorrect ou expiré",
    reset_change_email: "Changer l'adresse e-mail",
    reset_resend_code: "Renvoyer le code",
    reset_password_title: "Nouveau mot de passe",
    reset_password_subtitle: "Choisissez un nouveau mot de passe pour votre compte",
    reset_change_password_button: "Changer le mot de passe",
    reset_failed: "Échec de la réinitialisation du mot de passe",
    reset_success_title: "Mot de passe modifié !",
    reset_success_desc: "Votre mot de passe a été modifié avec succès.",
    reset_redirecting: "Redirection vers la page de connexion...",
  },

  // ==========================================
  // LAYOUT - PAGE TITLES
  // ==========================================
  layout: {
    dashboard: {
      page_title: "Tableau de bord",
    },
    auth: {
      page_title: "Se connecter",
    },
    web: {
      page_title: "Affiliate",
    },
  },

  // ==========================================
  // YOUCAN BANNER
  // ==========================================
  youcan: {
    new_badge: "ميزة جديدة —  نتائج أفضل!",
    title_prefix: "إربط متجرك مع",
    title_highlight: "YouCan",
    title_suffix: "بسهولة في لوحتك!",
    description: "يمكنك الآن ربط متجرك على YouCan، ونقل منتجاتك بكل سهولة، والاستفادة من استقبال الطلبات بشكل تلقائي دون أي تدخل يدوي.",
    synced_orders: "طلب مُزامَن",
    error_reduction: "تقليل الأخطاء اليدوية",
    continuous_sync: "مزامنة مستمرة 100%",
    cta: "ابدأ الآن ←",
  },

  // ==========================================
  // MODALS
  // ==========================================
  modals: {
    livreur_selection: {
      title: "Sélectionner un Livreur",
      orders_selected: "{count} commande(s) sélectionnée(s)",
      no_livreur: "Aucun livreur disponible",
      cancel: "Annuler",
      assigning: "Assignation...",
      confirm_assign: "Confirmer l'assignation",
    },
    ozon_invoice: {
      title: "Importer Facture Ozon",
      select_pdf: "Veuillez sélectionner un fichier PDF valide.",
      reading_pdf: "Lecture du PDF en cours…",
      drop_pdf: "Glissez votre facture PDF ici",
      click_to_select: "ou cliquez pour sélectionner",
      no_orders_selected: "Aucune commande sélectionnée.",
      updated: "Mis à jour",
      error: "Erreur",
      updated_success: "{count} commande(s) mise(s) à jour avec succès.",
      partial_success: "{ok} succès, {fail} échec(s).",
      status_delivered: "Livré",
      status_refused: "Refusé",
      total_colis: "Total colis :",
      delivered: "Livré :",
      refused: "Refusé :",
      selected: "Sélectionné :",
      table_code: "Code",
      table_phone: "Téléphone",
      table_city: "Ville",
      table_status: "Status",
      table_crbt: "Crbt",
      table_fees: "Frais",
      table_net: "Net",
      select_all_delivered: "Sélectionner tous les Livrés",
      info_only_delivered: "Seules les commandes Livré peuvent être sélectionnées. Le statut sera mis à jour en Livre(paye).",
      updating_orders: "Mise à jour des commandes en cours…",
      please_wait: "Veuillez patienter",
      success_count: "✓ Succès :",
      fail_count: "✗ Échecs :",
      result_code: "Code",
      result_city: "Ville",
      result_status: "Résultat",
      result_message: "Message",
      result_updated: "✓ Mis à jour",
      result_failed: "✗ Échec",
      close: "Fermer",
      change_file: "← Changer le fichier",
      import_count: "Importer {count} commande",
      new_import: "Nouvelle importation",
    },
  },

  // ==========================================
  // PRINT - DELIVERY TICKET
  // ==========================================
  print: {
    delivery_ticket: {
      boutique: "Boutique: {store}",
      contact_info: "{name} - Pour plus d'information appeler: {phone}",
      hub: "Hub",
      open: "Ouvrir",
      change: "Change",
      product_header: "Produit",
      qty_header: "Qté",
      total: "TOTAL: {total} DH",
      id_internal: "ID interne:",
      comment: "Commentaire:",
      send_date: "Date d'envoi: {date}",
    },
  },

  // ==========================================
  // FOOTER
  // ==========================================
  footer: {
    description: "أكثر منصات التسويق بالعمولة موثوقية في العالم. تواصل مع العلامات التجارية المتميزة وحقق أقصى إمكاناتك في الأرباح.",
    platform: "المنصة",
    platform_home: "الرئيسية",
    platform_about: "من نحن",
    platform_contact: "اتصل بنا",
    platform_affiliate: "برنامج الشركاء",
    resources: "الموارد",
    resources_help: "مركز المساعدة",
    resources_blog: "المدونة",
    resources_tutorials: "الدروس",
    resources_case_studies: "دراسات الحالة",
    resources_api: "وثائق API",
    legal: "القانوني",
    legal_privacy: "سياسة الخصوصية",
    legal_terms: "شروط الخدمة",
    legal_cookies: "سياسة الكوكيز",
    legal_gdpr: "الامتثال للائحة GDPR",
    legal_affiliate_disclosure: "إفصاح الشركاء",
    bottom_rights: "© {year} {name} - All rights reserved",
    bottom_privacy: "Privacy",
    bottom_terms: "Terms",
    bottom_cookies: "Cookies",
    bottom_sitemap: "Sitemap",
  },

  // ==========================================
  // PUBLIC HEADER
  // ==========================================
  public_header: {
    home: "الرئيسية",
    about: "من نحن",
    how_it_works: "كيف تعمل منصتنا؟",
    contact: "اتصل بنا",
    privacy: "سياسة الخصوصية",
    products: "المنتجات",
    login: "تسجيل الدخول",
  },

  // ==========================================
  // HOME PRODUCTS
  // ==========================================
  home: {
    products: {
      loading: "Chargement...",
      no_products: "Aucun produit disponible",
      commission: "Commission {commission}MAD",
      earn: "Gagnez: {earnings}MAD",
      promote_now: "Promouvoir",
    },
  },
  // ==========================================
  // CORS COMPONENTS
  // ==========================================
  cors_change_password: {
    account_security: 'Sécurité du Compte',
    cancel: 'Annuler',
    change_password: 'Changer le Mot de Passe',
    confirm_password: 'Confirmer le Nouveau Mot de Passe',
    confirm_placeholder: 'Confirmez votre nouveau mot de passe',
    enter_password: 'Entrez votre nouveau mot de passe',
    new_password: 'Nouveau Mot de Passe',
    password_protected: 'Votre mot de passe est protégé et crypté',
    password_too_short: 'Le mot de passe doit contenir au moins 6 caractères',
    passwords_mismatch: 'Les mots de passe ne correspondent pas',
    secure_password: 'Mot de Passe Sécurisé',
    update: 'Mettre à Jour',
    update_failed: 'Échec de la mise à jour du mot de passe',
    update_success: 'Mot de passe mis à jour avec succès!',
    updating: 'Mise à jour...',
  },
  cors_change_status: {
    add_details: 'Ajouter des détails',
    back: 'Retour',
    cancellation: 'annulation',
    cancel_desc: 'Annuler la commande avec raison',
    cancelled: 'Annulé',
    change_status: 'Changer le Statut',
    comment: 'Commentaire (optionnel)',
    confirm_action: 'Confirmer : {action}',
    confirm_desc: 'Confirmer la commande',
    confirmed: 'Confirmé',
    custom_reason: 'Raison personnalisée',
    describe_cancel_reason: 'Décrivez la raison de l\'annulation',
    describe_postpone_reason: 'Décrivez la raison du report',
    loading: 'Chargement...',
    order: 'Commande',
    optional: 'optionnel',
    perfect: 'Parfait !',
    postpone: 'report',
    postpone_date: 'Date de report',
    postpone_desc: 'Reporter la commande',
    postpone_reason: 'Raison du report',
    postponed: 'Reporté',
    reason: 'Raison',
    reason_no_answer_1: '1er appel pas de réponse',
    reason_no_answer_2: '2ème appel pas de réponse',
    reason_no_answer_3: '3ème appel pas de réponse',
    reason_not_interested: 'Pas intéressé',
    reason_other: 'Autre',
    reason_retry_later: 'Redouble',
    reason_traveling: 'En voyage',
    reason_unreachable: 'Injoignable',
    reason_voicemail: 'Boîte vocale',
    reason_wrong_number: 'Numéro Erronée',
    select_reason: 'Sélectionner une raison',
    status_updated: 'Statut mis à jour avec succès: {action}',
    success_with_action: 'Action réussie: {action}',
    update_error: 'Erreur de mise à jour',
    updated: 'Mis à jour',
  },
  cors_chat: {
    admin: 'Admin',
    confirmator: 'Confirmateur',
    no_messages: 'Aucun message pour le moment.',
    order: 'Commande',
    seller: 'Vendeur',
    system: 'System',
    type_message: 'Tapez un message...',
  },
  cors_confirmator_export: {
    all_statuses: 'Tous les statuts',
    cancel: 'Annuler',
    cancelled: 'Annulé',
    download_success: 'Fichier Excel téléchargé avec succès',
    end_date: 'Date de fin',
    error_occurred: 'Une erreur est survenue',
    export: 'Exporter',
    export_count: 'factures seront exportées',
    fetch_failed: 'Échec de la récupération des factures',
    loading: 'Chargement...',
    paid: 'Payé',
    pending: 'En attente',
    sheet_name: 'Factures Confirmateur',
    start_date: 'Date de début',
    status: 'Statut',
    title: 'Exporter vers Excel',
  },
  cors_confirmator_invoice: {
    banking_info: 'Informations Bancaires & Tarifs',
    cancelled: 'Annulé',
    confirm_price: 'Tarif Confirmation',
    confirmator_info: 'Informations Confirmateur',
    confirmed_orders: 'Commandes Confirmées',
    delivery: 'Livraison',
    footer_text: 'Facture générée automatiquement pour les services de confirmation.',
    generated_on: 'Générée le',
    invoice: 'Facture Confirmateur',
    invoice_title: 'FACTURE CONFIRMATEUR',
    invoice_total: 'Total Facture',
    issue_date: 'Date d\'émission',
    not_found: 'Facture confirmateur non trouvée',
    number: 'N°',
    order: 'Commande',
    paid: 'Réglé',
    payment_date: 'Date de paiement',
    pending_payment: 'Paiement en attente',
    products: 'Produits',
    rib: 'RIB',
    seller: 'Vendeur',
    status: 'Statut',
    total: 'Total',
    total_amount_desc: 'Montant total de la facture',
    total_orders: 'Nombre total de commandes',
    work_price: 'Tarif Travail',
  },
  cors_confirmator_rapport: {
    address: 'Adresse',
    bank: 'Banque',
    bank_label: 'Banque',
    cancelled: 'Annulé',
    code: 'Code',
    commission: 'Commission',
    confirmator_info: 'Informations Confirmateur',
    confirmed_orders: 'Commandes Confirmées',
    confirmed_orders_count: 'commande(s) confirmée(s)',
    delivery: 'Livraison',
    invoice_title: 'FACTURE CONFIRMATEUR',
    issued_on: 'Émise le',
    loading_invoice: 'Chargement de la facture...',
    method: 'Méthode',
    name: 'Nom',
    no_invoice_found: 'Aucune facture trouvée',
    number: 'N°',
    paid: 'Réglé',
    paid_on: 'Payé le',
    pending_payment: 'Paiement en attente',
    phone: 'Téléphone',
    price: 'Prix',
    print_error: 'Erreur lors de l\'impression',
    print_invoice: 'Imprimer la facture',
    products: 'Produits',
    seller: 'Vendeur',
    status: 'Statut',
    thank_you: 'Merci pour votre travail de confirmation !',
    total: 'Total',
    total_commissions: 'Total des commissions',
    unknown: 'Inconnu',
  },
  cors_delete_modal: {
    cancel: 'Annuler',
    cannot_undo: 'Cette action est irréversible.',
    close_modal: 'Fermer la modale',
    delete: 'Supprimer',
  },
  cors_duplicate_orders: {
    add_blacklist: 'Ajouter à la liste noire',
    address: 'Adresse',
    affiliate: 'Affiliate',
    amount: 'Montant',
    block: 'Bloquer',
    block_client: 'Bloquer le Client',
    block_reason_placeholder: 'raison de blocage...',
    cancel: 'Annuler',
    client: 'Client',
    client_blocked: 'Client bloqué avec succès!',
    client_unblocked: 'Client débloqué avec succès',
    code: 'Code',
    date: 'Date',
    error: 'Erreur',
    error_occurred: 'Une erreur est survenue',
    no_orders_found: 'Aucune commande trouvée',
    no_products: 'Aucun produit',
    order_history: 'Historique des commandes',
    orders: 'commande(s)',
    orders_will_appear: 'Les commandes apparaîtront ici',
    phone_unavailable: 'Numéro non disponible',
    processing: 'Traitement...',
    products: 'Produits',
    reason: 'Raison',
    status: 'Statut',
    tel: 'Tél',
    unblock: 'Débloquer',
    unblock_error: 'Erreur lors du déblocage',
  },
  cors_edit_invoice: {
    bank_transfer: 'Virement bancaire',
    cancel: 'Annuler',
    cancelled: 'Annulé',
    cash: 'Espèces',
    cheque: 'Chèque',
    credit_card: 'Carte bancaire',
    paid: 'Payé',
    payment_method: 'Méthode de paiement',
    pending_payment: 'En attente',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    select: '-- Sélectionner --',
    status: 'Statut',
    title: 'Modifier la facture',
  },
  cors_import: {
    accepted_formats: 'Formats acceptés: .xlsx, .xls',
    and_more_errors: 'et {count} autre(s) erreur(s)',
    check_docs: 'Consultez la documentation pour voir le format requis.',
    click_to_upload: 'Cliquez pour importer',
    close: 'Fermer',
    col_client_address: 'Adresse Client',
    col_client_city: 'Ville Client',
    col_client_name: 'Nom Client',
    col_client_phone: 'Téléphone Client',
    col_comment: 'Commentaire',
    col_product_id: 'ID Produit',
    col_product_qty: 'Quantité',
    col_selling_price: 'Prix de Vente',
    col_variants: 'Variantes',
    created_orders: 'commandes créées',
    data_preview: 'Aperçu des données',
    errors: 'Erreurs',
    failed_orders: 'commandes en échec',
    file_process_error: 'Erreur lors du traitement du fichier',
    file_read_error: 'Erreur lors de la lecture du fichier',
    format_required_desc: 'Le fichier doit contenir les colonnes suivantes:',
    format_required_title: 'Format requis',
    import: 'Importer',
    import_completed: 'Importation terminée',
    import_error: 'Erreur lors de l\'importation',
    import_success: '{count} commande(s) importée(s) avec succès!',
    importing: 'Importation en cours...',
    note_text: 'Note: Assurez-vous que votre fichier Excel suit le format requis.',
    select_excel: 'Veuillez sélectionner un fichier Excel valide.',
    select_file: 'Veuillez sélectionner un fichier.',
    select_file_label: 'Sélectionner un fichier Excel',
    showing_first_5: 'Affichage des 5 premières lignes',
    subtitle: 'Importez des commandes à partir d\'un fichier Excel',
    title: 'Importer des Commandes',
    total_lines: 'Lignes totales',
  },
  cors_invoice_modal: {
    bank: 'Banque',
    banking_info: 'Informations Bancaires',
    cancelled: 'Annulé',
    delivery: 'Livraison',
    footer_text: 'Merci d\'utiliser notre service. Cette facture est générée automatiquement et n\'a pas besoin de signature.',
    generated_on: 'Générée le',
    invoice: 'Facture',
    invoice_not_found: 'Facture non trouvée',
    issue_date: 'Date d\'émission',
    number: 'N°',
    order: 'Commande',
    order_details: 'Détails des Commandes',
    paid: 'Réglé',
    payment_date: 'Date de paiement',
    pending_payment: 'Paiement en attente',
    product: 'Produit',
    profit: 'Bénéfice',
    quantity: 'Quantité',
    rib: 'RIB',
    seller_info: 'Informations Vendeur',
    selling_price: 'Prix de Vente',
    status: 'Statut',
    total: 'Total',
    total_profit: 'Bénéfice Total',
    total_profit_desc: 'Somme des bénéfices de toutes les commandes',
    unit_price: 'Prix Unitaire',
  },
  cors_livreur_invoice: {
    auto_generated: 'Facture générée automatiquement.',
    bank_info: 'Informations Bancaires',
    cancelled: 'Annulé',
    city: 'Ville',
    client: 'Client',
    delivered: 'Livré',
    delivered_orders: 'Commandes Livrées',
    delivery_info: 'Informations Livreur',
    delivery_rate: 'Tarif Livraison',
    fixed_delivery_rate: 'Frais de livraison fixes',
    generated_on: 'Générée le',
    invoice_heading: 'FACTURE LIVREUR',
    invoice_number_label: 'N°:',
    invoice_title: 'Facture Livreur',
    invoice_total: 'Total Facture',
    issue_date: 'Date d\'émission',
    na: 'N/A',
    not_found: 'Facture livreur non trouvée',
    order: 'Commande',
    order_total: 'Total Commande',
    orders_included: 'commandes incluses',
    paid: 'Réglé',
    paid_on: 'Payé le',
    pending_payment: 'Paiement en attente',
    rib: 'RIB',
    status: 'Statut',
  },
  cors_livreur_report: {
    cancelled: 'Annulé',
    city: 'Ville',
    client: 'Client',
    code: 'Code',
    delivered_orders: 'Commandes Livrées',
    delivery_info: 'Informations Livreur',
    delivery_rate: 'Frais de livraison',
    emitted_on: 'Émise le',
    footer_thanks: 'Merci pour votre service de livraison !',
    invoice_title: 'FACTURE LIVREUR',
    loading_invoice: 'Chargement de la facture...',
    method: 'Méthode',
    name: 'Nom',
    no_invoice: 'Aucune facture trouvée',
    order_total: 'Total',
    orders_delivered_count: 'commande(s) livrée(s)',
    paid: 'Réglé',
    paid_on: 'Payé le',
    payment: 'Paiement',
    pending_payment: 'Paiement en attente',
    phone: 'Téléphone',
    print_error: 'Erreur lors de l\'impression',
    print_invoice: 'Imprimer la facture',
    total_to_pay: 'Total à payer',
    unknown: 'Inconnu',
    weight_vol: 'Poids/Vol.',
  },
  cors_map: {
    casablanca: 'Casablanca',
    loading_route: 'Chargement de l\'itinéraire...',
    route_title: 'Itinéraire',
  },
  cors_payment_method: {
    bank_transfer: 'Virement bancaire',
    cancel: 'Annuler',
    cash: 'Espèces',
    cheque: 'Chèque',
    choose_method: 'Choisir la méthode de paiement',
    confirm_payment: 'Confirmer le paiement',
    credit_card: 'Carte de crédit',
    processing: 'Traitement...',
    select_method: 'Veuillez sélectionner une méthode de paiement',
    select_prompt: 'Sélectionnez la méthode de paiement utilisée pour régler cette facture :',
  },
  cors_permissions: {
    add_category: 'Ajouter Catégorie',
    add_product: 'Ajouter Produit',
    add_stock: 'Ajouter Stock',
    add_variant: 'Ajouter Variante',
    confirm_compte: 'Confirmer Comptes',
    confirm_orders: 'Confirmer Commandes',
    delete_category: 'Supprimer Catégorie',
    delete_product: 'Supprimer Produit',
    delete_stock: 'Supprimer Stock',
    delete_variant: 'Supprimer Variante',
    edit_config: 'Modifier Configuration',
    edit_users: 'Modifier Utilisateurs',
    no_permissions: 'Aucune permission accordée',
    title: 'Permissions & Accès',
  },
  cors_saller_export: {
    cancel: 'Annuler',
    create_error: 'Erreur lors de la création du fichier Excel',
    download_success: 'Fichier Excel téléchargé avec succès!',
    fetch_error: 'Erreur lors de la récupération des données',
    invoices_count: 'factures',
    invoices_sheet: 'Factures',
    no_data: 'Aucune donnée à exporter pour',
    no_invoices: 'Aucune facture trouvée pour',
    select_bank: 'Sélectionner la Banque pour l\'Export',
  },
  cors_saller_rapport: {
    address: 'Adresse',
    bank: 'Banque',
    bank_label: 'Banque',
    cancelled: 'Annulé',
    delivery: 'Livraison',
    invoice: 'FACTURE',
    issued_on: 'Émise le',
    loading_invoice: 'Chargement de la facture...',
    method: 'Méthode',
    no_invoice_found: 'Aucune facture trouvée',
    number: 'N°',
    order: 'Commande',
    order_details: 'Détails des Commandes',
    orders_count: 'commande(s)',
    paid: 'Réglé',
    paid_on: 'Payé le',
    pending_payment: 'Paiement en attente',
    phone: 'Téléphone',
    print_error: 'Erreur lors de l\'impression',
    print_invoice: 'Imprimer la facture',
    product: 'Produit',
    profit: 'Bénéfice',
    qty: 'Qté',
    seller_info: 'Informations Vendeur',
    selling_price: 'Prix Vente',
    status: 'Statut',
    thank_you: 'Merci pour votre confiance !',
    total: 'Total',
    total_profit: 'Bénéfice total de la facture',
    unit_price: 'Prix Unitaire',
    unknown: 'Inconnu',
  },
  cors_select_sallers: {
    cancel: 'Annuler',
    description: 'Sélectionnez les vendeurs avec lesquels ce confirmateur peut travailler:',
    edit_sellers: 'Modifier les Vendeurs',
    no_sellers_found: 'Aucun vendeur trouvé',
    no_sellers_selected: 'Aucun vendeur sélectionné',
    save: 'Enregistrer',
    search_placeholder: 'Rechercher et sélectionner des vendeurs...',
    title: 'Les Vendeurs de ce confirmateur',
    update_error: 'Erreur de mise à jour du confirmateur',
    update_success: 'Confirmateur mis à jour avec succès !',
    updating: 'Mise à jour...',
  },
  cors_status_history: {
    comment: 'Commentaire',
    current_status: 'Statut actuel',
    last_update: 'Dernière mise à jour',
    postponed_to: 'Reporté au',
    reason: 'Raison',
    status_count: 'changement(s) de statut',
    subtitle: 'Historique des changements de statut pour',
    title: 'Historique des Statuts',
  },
  cors_status_livreur: {
    add_details: 'Ajouter des détails',
    back: 'Retour',
    back_delivery: 'Retour Livraison',
    back_delivery_desc: 'Marquer comme retour de livraison',
    back_delivery_success: ' retour de livraison enregistré avec succès',
    cancel_desc: 'Annuler la livraison avec raison',
    cancelled: 'Annulé',
    change_status: 'Changer le Statut',
    comment: 'Commentaire (optionnel)',
    confirm: 'Confirmer',
    custom_reason: 'Raison personnalisée',
    delivered: 'Livré',
    delivered_success: ' livré avec succès',
    describe_reason: 'Décrivez la raison',
    loading: 'Chargement...',
    mark_delivered: 'Marquer comme livré',
    no_answer: 'Pas de Réponse',
    no_answer_desc: 'Client n\'a pas répondu',
    no_answer_success: ' pas de réponse enregistré avec succès',
    order: 'Commande',
    perfect: 'Parfait !',
    postpone_date: 'Date de report',
    postpone_desc: 'Reporter la livraison',
    postpone_reason: 'Raison du report',
    postponed: 'Reporté',
    reason_client_refused_package: 'Client refuse le colis',
    reason_duplicate_order: 'Double commande',
    reason_no_answer: 'Pas de réponse',
    reason_not_interested: 'Pas intéressé',
    reason_other: 'Autre',
    reason_out_of_zone: 'Hors zone',
    reason_traveling: 'En voyage',
    reason_unreachable: 'Injoignable',
    reason_wrong_number: 'Numéro erroné',
    reason_wrong_price: 'Prix incorrect',
    reason_wrong_product: 'Produit incorrect',
    refused: 'Refusé',
    refused_desc: 'Client a refusé la commande',
    select_reason: 'Sélectionner une raison',
    status_success: 'Statut mis à jour avec succès : {status}',
    update_error: 'Erreur de mise à jour',
  },
  cors_saller_bank: {
    other: 'Autre',
  },
  cors_status_map: {
    nouveau: 'Nouvelle',
    confirme: 'Confirmé',
    paid: 'Réglé',
    reporte: 'Confirmation reportée',
    nonconfirme: 'Non confirmé',
    indelivery: 'En livraison',
    livre: 'Livré',
    livre_paye: 'Livré (Payé)',
    pending_payment: 'Paiement en attente',
    retour: 'Retourné',
    refuse: 'Refusé',
    refuse_par_livreur: 'Refusé par livreur',
    annule: 'Annulé',
    duplicated: 'Dupliqué',
    attente_de_ramassage: 'Attente De Ramassage',
    ramasse: 'Ramassé',
    expedie: 'Expédié',
    pret_pour_expedition: 'Prêt pour expédition',
    mise_en_distribution: 'Mise en distribution',
    programme: 'Programmé',
    interesse: 'Interessé',
    recu_par_livreur: 'Reçu par livreur',
    envoye_a_l_agence: 'Envoyé à l\'agence',
    recu_en_agence_de_livraison: 'Reçu En Agence De Livraison',
    reporte_par_livreur: 'Reporté par livreur',
    en_voyage: 'En voyage',
    en_cours_de_livraison: 'En cours de livraison',
    pre_ramasse: 'Pré ramassé',
    en_cours_de_preparation: 'En cours de préparation',
    en_livraison: 'En livraison',
    en_transport: 'En Transport',
    client_disponible_pour_livraison: 'Client disponible pour livraison',
    recu_sur_agence_casa: 'Reçu sur agence Casa',
    demande_de_retour: 'Demande de retour',
    retour_client_expedie: 'Retour client expédié',
    retour_vers_agence_casa: 'Retour vers agence Casa',
    retour_vers_agence_casa_alt: 'Retour vers Agence Casa',
    retour_recu_agence_casa: 'Retour Reçu Agence Casa',
    retour_recu_agence_casa_alt: 'Retour Reçu Agence Casa',
    retour_recu_par_agence: 'Retour reçu par agence',
    retour_recu_par_livreur: 'Retour reçu par livreur',
    retour_client_recu: 'Retour client Reçu',
    retour_pret_pour_expedition: 'Retour prêt pour l\'expédition',
    a_retourner_vers_agence_principal_casa: 'A retourner vers agence principal casa',
    retour_expedie: 'Retour expédié',
    retour_recu_par_city: 'Retour reçu par {{city}}',
    colis_pret_pour_le_retour: 'Colis prêt pour le retour',
    retour_en_cours_de_la_livraison: 'Retour en cours de la livraison',
    retour_debarrasse: 'Retour débarrassé',
    retour_en_stock: 'Retour en stock',
    retour_recu: 'Retour reçu',
    retour_client_recu_alt: 'Retour client reçu',
    sans_adresse: 'Sans adresse',
    injoignable: 'Injoignable',
    boite_vocal: 'Boite Vocal',
    pas_de_reponse: 'Pas de réponse',
    pas_de_reponse_2_fois: 'Pas de réponse 2 fois',
    pas_de_reponse_2_fois_alt: 'Pas de réponse 2 fois',
    pas_de_reponse_3_fois: 'Pas de réponse 3 fois',
    pas_de_reponse_3_fois_alt: 'Pas de réponse 3 fois',
    pas_de_reponse_j_2: 'Pas de réponse J+2',
    pas_de_reponse_j_3: 'Pas de réponse J+3',
    pas_reponse_deplacement_j_2: 'pas réponse + déplacement J+2',
    pas_reponse_deplacement_j_3: 'pas réponse + déplacement J+3',
    pas_reponse_deplacement: 'pas réponse +déplacement',
    pas_de_reponse_suivi: 'Pas de reponse ( SUIVI )',
    injoignable_suivi: 'Injoignable ( SUIVI )',
    reporte_suivi: 'Reporté ( SUIVI )',
    boite_vocal_suivi: 'Boite Vocal ( SUIVI )',
    faux_destination: 'Fausse destination',
    hors_zone: 'Hors zone',
    hors_zone_alt: 'Hors-zone',
    pas_interesse: 'Pas intéressé',
    produit_endommage: 'Produit endommagé',
    perdu: 'Perdu',
    demande_de_suivi: 'Demande de suivi',
    annule_suivi: 'Annulé (SUIVI)',
    annule_par_livreur: 'Annulé par livreur',
    changement_adresse: 'Changement d\'adresse',
    changement_d_adresse: 'Changement d\'adresse',
    recu_par_erreur: 'Reçu par erreur',
    non_recu: 'Non reçu',
    colis_archive: 'Colis archivé',
    reportee_indefiniment: 'Reportée indéfiniment',
    reporte_aujourd_hui: 'Reporté aujourd hui',
    erreur_numero: 'Erreur Numero',
    rembourse: 'Remboursé',
  },
  // ==========================================
  // WEBSITES - Nextlead & Topseller pages
  // ==========================================
  websites: {
    nextlead: {
      home: {
        badge_platform_rank: "Plateforme n°1 du marketing d'affiliation dans le monde arabe",
        hero_title_1: "Gagnez plus avec",
        hero_title_2: "les partenaires marketing premium",
        hero_desc: "Rejoignez plus de {count} spécialistes du marketing arabes qui gagnent jusqu'à {amount} par mois en promouvant des produits mondiaux avec des commissions allant jusqu'à 80%",
        cta_start_earning: "Commencez à gagner gratuitement maintenant",
        cta_watch_demo: "Voir la démo",
        stat_marketers: "Spécialistes marketing actifs",
        stat_profits_distributed: "Bénéfices distribués",
        stat_client_rating: "Note des clients",
        why_choose_us: "Pourquoi choisir",
        why_choose_desc: "Nous fournissons des solutions complètes pour construire des activités de marketing d'affiliation réussies et rentables",
        feat_commission_title: "Commissions jusqu'à 80%",
        feat_commission_desc: "Les taux de commission les plus élevés du marché avec paiement hebdomadaire",
        feat_protection_title: "Protection intégrée",
        feat_protection_desc: "Système de suivi avancé pour prévenir la fraude et confirmer les transactions",
        feat_instant_title: "Transferts instantanés",
        feat_instant_desc: "Retirez vos bénéfices directement sur votre compte bancaire en 24 heures",
        feat_analytics_title: "Analyses intelligentes",
        feat_analytics_desc: "Rapports de performance détaillés avec prévisions IA",
        feat_support_title: "Communauté de soutien",
        feat_support_desc: "Rejoignez une communauté de spécialistes du marketing et d'experts à succès",
        feat_247_title: "Support 24/7",
        feat_247_desc: "Équipe de support technique disponible 24h/24 et 7j/7",
        how_it_works: "Comment ça marche",
        how_it_works_subtitle: "Des étapes simples pour gagner",
        how_it_works_desc: "Seulement 6 étapes vous séparent de votre première vente",
        step1_title: "Inscription gratuite",
        step1_desc: "Créez votre compte gratuitement en quelques minutes",
        step2_title: "Choisir des produits",
        step2_desc: "Parcourez des milliers de produits à haut rendement",
        step3_title: "Promouvoir et gagner",
        step3_desc: "Créez des liens de marketing et commencez à gagner",
        step4_title: "Suivre les ventes",
        step4_desc: "Suivez vos performances en temps réel avec des statistiques précises",
        step5_title: "Confirmer les commandes",
        step5_desc: "Nous gérons la confirmation, l'expédition et la livraison",
        step6_title: "Retirer les gains",
        step6_desc: "Retirez vos gains chaque semaine facilement et en toute sécurité",
        browse_by_category: "Parcourir les produits par",
        browse_by_category_subtitle: "Catégories populaires",
        browse_by_category_desc: "Choisissez parmi des milliers de produits dans diverses catégories",
        cat_electronics: "Électronique",
        cat_beauty: "Beauté et soins",
        cat_health: "Santé et sport",
        cat_home: "Maison et cuisine",
        cat_fashion: "Mode et accessoires",
        cat_education: "Éducation et livres",
        integrations_title: "Intégration complète avec",
        integrations_subtitle: "Les plateformes mondiales les plus célèbres",
        integrations_desc: "Nous fournissons une intégration transparente avec toutes les plateformes de commerce électronique et outils marketing",
        integration_status_active: "Actif",
        integration_status_soon: "Bientôt",
        integration_youcan: "Intégration complète avec la plateforme YouCan e-commerce",
        integration_shopify: "Connexion directe avec les boutiques Shopify",
        integration_woocommerce: "Intégration avec WooCommerce et les boutiques WordPress",
        integration_sheets: "Intégration avec les outils Google et leurs analyses",
        integration_custom_api: "API personnalisées pour tout système",
        custom_platform_title: "Vous avez un système personnalisé ?",
        custom_platform_desc: "Nous fournissons des API complètes pour l'intégration avec tout système personnalisé",
        custom_platform_cta: "Découvrez les options d'intégration avancées",
        products_title: "Nos produits",
        products_subtitle: "Les plus rentables et convertissants",
        products_desc: "Choisissez parmi des milliers de produits à fort taux de conversion avec des marges de profit exceptionnelles",
        product_high_conversion: "Taux de conversion les plus élevés",
        product_commission_80: "Commissions jusqu'à 80%",
        product_fast_shipping: "Expédition rapide mondiale",
        featured_products: "Produits populaires",
        featured_products_desc: "Produits les mieux notés par les spécialistes du marketing",
        browse_all_products: "Parcourir tous les produits ({count})",
        testimonials_title: "Ce que disent",
        testimonials_subtitle: "nos spécialistes du marketing",
        testimonials_desc: "Rejoignez des milliers de spécialistes du marketing à succès qui nous font confiance",
        testimonial1_name: "Ahmed Mohamed",
        testimonial1_role: "Marketeur Instagram",
        testimonial1_content: "J'ai commencé avec la plateforme il y a 6 mois et j'ai réalisé plus de 25 000 SAR de bénéfices. La plateforme a complètement changé ma vie financière.",
        testimonial2_name: "Sara Al-Otaibi",
        testimonial2_role: "Blogueuse beauté",
        testimonial2_content: "La plateforme la plus facile avec laquelle j'ai travaillé. Les transferts sont rapides et le support est excellent. Je la recommande à tous ceux qui veulent se lancer dans le marketing d'affiliation.",
        testimonial3_name: "Khaled Al-Zahrani",
        testimonial3_role: "Propriétaire de boutique en ligne",
        testimonial3_content: "Mes produits ont atteint des milliers de nouveaux clients grâce aux marketeurs de la plateforme. Mes ventes ont augmenté de 300% en 3 mois.",
        choose_model: "Choisissez votre modèle",
        choose_model_subtitle: "et commencez à gagner aujourd'hui",
        choose_model_desc: "Que vous soyez spécialiste du marketing ou vendeur, nous avons la solution idéale pour vos besoins",
        model_affiliate: "Spécialiste du marketing d'affiliation",
        model_affiliate_badge: "Idéal pour les marketeurs, influenceurs et blogueurs",
        model_affiliate_item1: "Gagnez jusqu'à 80% de commission sur chaque vente",
        model_affiliate_item2: "Accès à plus de 10 000 produits",
        model_affiliate_item3: "Outils de suivi et d'analyse avancés",
        model_affiliate_item4: "Support technique spécialisé 24/7",
        model_affiliate_item5: "Retrait des gains chaque semaine",
        model_affiliate_cta: "Inscrivez-vous en tant que marketeur gratuitement",
        model_vendor: "Vendeur/commerçant",
        model_vendor_badge: "Idéal pour les marques, entreprises et magasins",
        model_vendor_item1: "Présentez vos produits à des milliers de marketeurs",
        model_vendor_item2: "Gestion centralisée des commandes et expéditions",
        model_vendor_item3: "Intégration avec toutes les plateformes",
        model_vendor_item4: "Rapports de vente détaillés",
        model_vendor_item5: "Protection contre la fraude",
        model_vendor_cta: "Inscrivez-vous en tant que vendeur gratuitement",
        cta_final_badge: "Plateforme primée - Meilleure plateforme marketing 2024",
        cta_final_title: "Commencez votre voyage vers",
        cta_final_subtitle: "l'indépendance financière aujourd'hui",
        cta_final_desc: "Rejoignez la communauté des spécialistes du marketing à succès qui ont transformé leur passion en revenus durables. Aucune expérience préalable nécessaire - nous vous apprendrons tout à partir de zéro.",
        cta_final_register: "Inscrivez votre compte gratuit maintenant",
        cta_final_consult: "Réservez une consultation gratuite avec un expert",
        cta_final_fees: "Aucuns frais",
        cta_final_no_fees: "Aucuns frais du tout",
        cta_final_guarantee: "Garantie de profit",
        cta_final_support: "Support arabe spécialisé",
      },
      about: {
        hero_badge: "Depuis 2019, nous changeons le concept du marketing d'affiliation",
        hero_title_1: "Une histoire de réussite",
        hero_title_2: "qui a changé la vie de milliers de personnes",
        hero_desc: "Nous avons démarré avec une vision claire : créer une plateforme offrant des partenariats réels et rentables entre les spécialistes du marketing créatifs et les marques exceptionnelles. Aujourd'hui, nous sommes fiers d'être devenus la plateforme leader dans le monde arabe pour le marketing d'affiliation.",
        cta_join: "Rejoignez notre communauté",
        cta_contact: "Contactez notre équipe",
        story_badge: "Notre vision et notre mission",
        story_title: "Pourquoi sommes-nous différents ?",
        story_p1: "Nous avons commencé notre voyage en 2019 après avoir remarqué une lacune importante sur le marché du marketing d'affiliation. Nous avons vu des spécialistes du marketing talentueux lutter avec des commissions faibles, des paiements en retard et un manque de transparence.",
        story_p2: "De l'autre côté, les marques avaient du mal à trouver des partenaires fiables pour promouvoir leurs produits avec honnêteté et professionnalisme.",
        story_p3: "Nous avons décidé de changer cette image en construisant une plateforme qui place les intérêts des partenaires en premier. Aujourd'hui, nous connectons plus de {count} spécialistes du marketing avec les meilleures marques, et facilitons des millions de commissions chaque année tout en maintenant les normes les plus élevées de qualité et de transparence.",
        story_check1: "Commissions jusqu'à 80%",
        story_check2: "Paiements hebdomadaires",
        story_check3: "Support technique 24/7",
        story_check4: "Produits de qualité garantie",
        impact_title: "Notre impact en chiffres",
        impact_subtitle: "Des succès dont nous sommes fiers",
        impact_desc: "Des chiffres réels qui reflètent la confiance de notre communauté et le succès de nos partenariats",
        stat_marketers: "Spécialistes du marketing actifs",
        stat_marketers_desc: "Un nouveau marketeur nous rejoint chaque heure",
        stat_profits: "Bénéfices distribués",
        stat_profits_desc: "Commissions versées à nos partenaires",
        stat_countries: "Pays",
        stat_countries_desc: "Présence mondiale sur 5 continents",
        stat_rating: "Note des clients",
        stat_rating_desc: "Basé sur plus de 15 000 avis",
        stat_products: "Produits populaires",
        stat_products_desc: "Des meilleures marques",
        stat_support: "Support technique",
        stat_support_desc: "Support continu 24h/24",
        values_title: "Nos valeurs fondamentales",
        values_subtitle: "qui nous guident chaque jour",
        values_desc: "Ces principes rendent notre plateforme unique et garantissent le succès de nos partenariats",
        value1_title: "Intégrité et transparence",
        value1_desc: "Nous croyons que l'intégrité est le fondement de tout partenariat réussi",
        value2_title: "Succès des partenaires d'abord",
        value2_desc: "Notre succès se mesure au succès de nos partenaires marketeurs et vendeurs",
        value3_title: "Innovation continue",
        value3_desc: "Nous développons des outils innovants pour faciliter votre travail et augmenter vos profits",
        value4_title: "Protection et sécurité",
        value4_desc: "Nous protégeons vos gains et vos données avec des systèmes de sécurité avancés",
        timeline_title: "Le parcours de réussite",
        timeline_subtitle: "Du début au sommet",
        timeline_desc: "Étapes importantes dans la construction de la plateforme leader du marketing d'affiliation",
        milestone1_year: "2019",
        milestone1_title: "Fondation de l'entreprise",
        milestone1_desc: "Notre lancement avec la vision de changer le concept du marketing d'affiliation",
        milestone2_year: "2020",
        milestone2_title: "Premiers 1000 marketeurs",
        milestone2_desc: "Nous avons dépassé la barre des 1000 marketeurs actifs en moins d'un an",
        milestone3_year: "2021",
        milestone3_title: "Expansion de l'équipe",
        milestone3_desc: "Notre équipe s'est agrandie à 50 employés et consultants",
        milestone4_year: "2022",
        milestone4_title: "Plateforme intégrée",
        milestone4_desc: "Lancement de la plateforme complète avec gestion intégrale des opérations",
        milestone5_year: "2023",
        milestone5_title: "Plateforme mondiale",
        milestone5_desc: "Nous avons atteint 50 pays à travers le monde",
        milestone6_year: "2024",
        milestone6_title: "Prix et reconnaissance",
        milestone6_desc: "Nous avons remporté le prix de la meilleure plateforme marketing de la région",
        team_badge: "Équipe de direction",
        team_title: "Les esprits créatifs",
        team_subtitle: "derrière votre succès",
        team_desc: "Une équipe d'experts et de passionnés qui travaillent jour et nuit pour assurer votre réussite",
        team_member1_name: "Ahmed Al-Khalid",
        team_member1_title: "Fondateur et PDG",
        team_member1_desc: "15+ ans d'expérience en marketing numérique, a fondé 3 entreprises prospères",
        team_member2_name: "Sara Al-Otaibi",
        team_member2_title: "Directrice technique",
        team_member2_desc: "Ingénieure logicielle avec 12+ ans d'expérience dans le développement de plateformes",
        team_member3_name: "Mohamed Al-Qahtani",
        team_member3_title: "Directeur marketing",
        team_member3_desc: "Expert en marketing numérique avec 10+ ans dans la construction de marques",
        team_member4_name: "Fatima Al-Zahrani",
        team_member4_title: "Directrice des opérations",
        team_member4_desc: "Spécialiste en gestion des opérations avec 8+ ans d'expérience",
        team_cta_desc: "Nous croyons que votre succès est notre succès. C'est pourquoi nous travaillons chaque jour à développer des outils et services qui vous aident à maximiser votre potentiel.",
        team_cta: "Rejoignez notre équipe",
        cta_badge: "Faites partie de l'avenir du marketing",
        cta_title: "Prêt à commencer votre voyage avec nous ?",
        cta_subtitle: "Rejoignez la communauté des réussites",
        cta_desc: "Que vous soyez un marketeur débutant ou professionnel, ou que vous possédiez une marque cherchant des partenaires fiables, nous vous garantissons une expérience exceptionnelle avec les taux de profit les plus élevés et un soutien continu.",
        cta_start: "Commencez à gagner gratuitement",
        cta_consult: "Contactez un conseiller",
        years_excellence: "Années d'excellence",
        years_excellence_desc: "À la tête de l'industrie du marketing",
      },
      contact: {
        hero_badge: "Support rapide et efficace 24/7",
        hero_title: "Nous sommes là pour vous aider",
        hero_subtitle: "à chaque étape",
        hero_desc: "Notre équipe de support est disponible 24h/24 pour répondre à vos questions et résoudre vos problèmes.",
        cta_call: "Appelez-nous maintenant",
        cta_chat: "Démarrer une conversation",
        section_title: "Contactez-nous",
        section_subtitle: "de la manière appropriée",
        section_desc: "Choisissez la méthode appropriée pour contacter l'équipe de support",
        method_phone: "Appel téléphonique",
        method_phone_desc: "Disponible du lundi au samedi 9h - 18h",
        method_email: "E-mail",
        method_email_desc: "Réponse sous 2 heures",
        method_chat: "Chat en direct",
        method_chat_desc: "Disponible 24h/24",
        method_office: "Bureau principal",
        method_office_desc: "Visite sur rendez-vous",
        stat_avg_time: "Temps de réponse moyen",
        stat_satisfaction: "Satisfaction client",
        stat_continuous: "Support continu",
        stat_max_resolution: "Temps de résolution max",
        form_title: "Envoyez-nous votre message",
        form_desc: "Remplissez le formulaire et notre équipe vous répondra dès que possible",
        form_name: "Nom complet *",
        form_name_placeholder: "Entrez votre nom complet",
        form_email: "E-mail *",
        form_email_placeholder: "example.domain.com",
        form_phone: "Numéro de téléphone",
        form_phone_placeholder: "+212 663610738",
        form_subject_type: "Type de demande *",
        form_subject_type_placeholder: "Choisissez le type de demande",
        form_subject_type_technical: "Support technique",
        form_subject_type_account: "Demande de compte",
        form_subject_type_payment: "Demande financière",
        form_subject_type_partnership: "Partenariat commercial",
        form_subject: "Sujet *",
        form_subject_placeholder: "Titre du message",
        form_message: "Message *",
        form_message_placeholder: "Écrivez votre message...",
        form_newsletter: "Je souhaite recevoir des newsletters",
        form_submit: "Envoyer le message",
        quick_actions: "Actions rapides",
        quick_action_ticket: "Ouvrir un ticket de support",
        quick_action_ticket_desc: "Signalez un problème ou une demande",
        quick_action_call: "Planifier un appel",
        quick_action_call_desc: "Réservez un appel avec un conseiller",
        quick_action_help: "Visiter le centre d'aide",
        quick_action_help_desc: "Explorez les articles et tutoriels",
        support_categories: "Catégories de support",
        support_technical: "Support technique",
        support_technical_desc: "Problèmes techniques ou questions sur la plateforme",
        support_payments: "Questions financières",
        support_payments_desc: "Questions sur les paiements et commissions",
        support_accounts: "Support des comptes",
        support_accounts_desc: "Modifications de compte, activation et problèmes",
        support_faq: "FAQ",
        support_faq_desc: "Réponses aux questions les plus fréquentes",
        faq_title: "Questions",
        faq_subtitle: "fréquentes",
        faq_desc: "Réponses aux questions les plus courantes sur le support",
        faq_q1: "Combien de temps pour répondre aux demandes de support ?",
        faq_a1: "Nous répondons aux e-mails sous 4 heures ouvrables, et au chat en direct en quelques minutes.",
        faq_q2: "Avez-vous un support en arabe ?",
        faq_a2: "Oui, toute notre équipe de support parle arabe. Vous pouvez nous contacter en arabe sur tous les canaux.",
        faq_q3: "Quels sont les horaires du support technique ?",
        faq_a3: "Le chat en direct et le support technique sont disponibles 24/7. Les appels téléphoniques du dimanche au jeudi de 9h à 18h.",
        faq_browse_all: "Parcourir toutes les questions",
        office_badge: "Informations du bureau",
        office_title: "Visitez notre bureau",
        office_subtitle: "Nous vous accueillons toujours",
        office_address: "Derb Omar, Casablanca",
        office_country: "Maroc",
        office_address_title: "Adresse",
        office_hours_title: "Horaires d'ouverture",
        office_hours: "Lundi - Samedi : 9h00 - 18h00",
        office_visit_cta: "Réserver une visite au bureau",
        cta_badge: "Nous sommes là pour vous servir",
        cta_title: "Vous avez une question ?",
        cta_subtitle: "N'hésitez pas à nous contacter",
        cta_desc: "Notre équipe de support est prête à répondre à toutes vos questions et à résoudre tout problème que vous rencontrez.",
        cta_call_now: "Appelez-nous maintenant",
        cta_email: "Envoyez un e-mail",
        cta_footer: "Temps de réponse moyen : 4 heures • Taux de satisfaction : 98% • Support continu 24/7",
      },
      policy: {
        hero_badge: "Votre vie privée est notre priorité",
        hero_title: "Politique de",
        hero_subtitle: "confidentialité",
        hero_desc: "Votre vie privée est importante pour nous. Cette politique explique comment nous collectons, utilisons et protégeons vos informations.",
        last_updated: "Dernière mise à jour : 1 janvier 2024",
        section_collect_title: "Informations que nous collectons",
        section_collect_subtitle: "Informations personnelles",
        section_collect_desc: "Nous collectons les informations que vous nous fournissez directement, comme la création de compte, l'adhésion au programme partenaire ou la demande de support.",
        collect_item1: "Nom et coordonnées (e-mail, téléphone)",
        collect_item2: "Informations de paiement et fiscales pour les transferts",
        collect_item3: "Réseaux sociaux pour authentifier le partenariat",
        collect_item4: "Préférences de communication et choix marketing",
        section_use_title: "Comment nous utilisons vos informations",
        use_category1_title: "Gestion de compte",
        use_category1_item1: "Création et gestion de compte partenaire",
        use_category1_item2: "Traitement des paiements",
        use_category1_item3: "Fourniture de support technique",
        use_category1_item4: "Envoi de notifications importantes du compte",
        use_category2_title: "Amélioration du service",
        use_category2_item1: "Analyse des performances et de l'utilisation",
        use_category2_item2: "Développement de nouvelles fonctionnalités et services",
        use_category2_item3: "Prévention de la fraude et des abus",
        use_category2_item4: "Renforcement de la sécurité de la plateforme",
        section_share_title: "Partage d'informations",
        section_share_subtitle: "Nous ne vendrons jamais vos données",
        section_share_desc: "Nous ne vendons, louons ou échangeons pas vos données personnelles avec des tiers à des fins marketing. Nous partageons les informations uniquement dans les cas suivants :",
        share_item1: "Avec des partenaires commerciaux pour faciliter la relation",
        share_item2: "Avec des prestataires de services pour exploiter la plateforme",
        share_item3: "Si la loi l'exige ou pour protéger nos droits",
        share_item4: "En cas de fusion ou de transfert d'activité",
        section_security_title: "Sécurité des données",
        section_security_subtitle: "Protection de niveau entreprise",
        section_security_desc: "Nous mettons en œuvre des mesures de sécurité standard pour protéger vos informations personnelles :",
        security_tech_title: "Mesures techniques",
        security_tech_item1: "Chiffrement SSL/TLS pour le transfert de données",
        security_tech_item2: "Chiffrement AES-256 pour les données stockées",
        security_tech_item3: "Tests de sécurité périodiques",
        security_tech_item4: "Authentification multifacteur",
        security_ops_title: "Mesures opérationnelles",
        security_ops_item1: "Accès limité aux données",
        security_ops_item2: "Formation à la sécurité pour les employés",
        security_ops_item3: "Procédures de réponse aux incidents",
        security_ops_item4: "Sauvegarde et test de restauration",
        section_rights_title: "Vos droits et choix",
        right1_title: "Accès et contrôle",
        right1_desc: "Vous pouvez accéder, mettre à jour ou supprimer vos informations personnelles à tout moment via le tableau de bord ou en nous contactant.",
        right2_title: "Communications marketing",
        right2_desc: "Vous pouvez vous désabonner des e-mails marketing à tout moment via le lien de désabonnement ou les paramètres du compte.",
        right3_title: "Portabilité des données",
        right3_desc: "Vous pouvez demander une copie de vos données dans un format lisible par machine ou les transférer vers un autre fournisseur.",
        section_contact_title: "Contactez-nous",
        section_contact_desc: "Si vous avez des questions concernant la politique de confidentialité ou les pratiques en matière de données, veuillez nous contacter :",
        contact_privacy_officer: "Responsable de la protection des données",
        contact_address_title: "Adresse postale",
        contact_address_company: "Société Nextlead-Affiliate",
        contact_address_city: "Riyad, Arabie Saoudite",
        section_updates_title: "Mises à jour de la politique",
        section_updates_desc: "Nous pouvons mettre à jour cette politique de temps à autre pour refléter les changements. Nous vous informerons des modifications en mettant à jour la page et la date de 'Dernière mise à jour'.",
      },
      components: {
        homeProducts: {
          loading: "Chargement...",
          no_products: "Aucun produit disponible",
          commission: "Commission {commission}MAD",
          earn: "Gagnez: {earnings}MAD",
          promote_now: "Promouvoir",
        },
        productSliders: {
          loading: "Chargement...",
          new_arrival: "Nouvel arrivage",
          most_requested: "Les produits les plus demandés",
          shop_now: "Acheter maintenant",
        },
      },
    },
    topseller: {
      home: {
        hero_badge: "Plateforme marketing n°1",
        hero_title_1: "Gagnez plus avec",
        hero_title_2: "les partenaires marketing premium",
        hero_desc: "Une plateforme intégrée réunissant vendeurs et spécialistes du marketing pour créer une expérience de profit exceptionnelle. Commencez votre parcours de génération de revenus avec des outils professionnels et un réseau fiable.",
        cta_start: "Commencez gratuitement maintenant",
        cta_watch: "Voir comment ça marche",
        stat_marketers: "Spécialistes du marketing à succès",
        stat_avg_profit: "Profit moyen",
        features_badge: "Pourquoi nous choisir ?",
        features_title: "Plateforme conçue pour le succès",
        features_subtitle: "des marketeurs de l'ère numérique",
        feat1_title: "Commissions compétitives",
        feat1_desc: "Gagnez jusqu'à 70% de commission sur chaque vente",
        feat2_title: "Produits à fort taux de conversion",
        feat2_desc: "Promouvez des produits soigneusement sélectionnés de marques de confiance",
        feat3_title: "Analyses avancées",
        feat3_desc: "Informations basées sur l'IA pour améliorer vos performances",
        feat4_title: "Paiement sécurisé",
        feat4_desc: "Paiements réguliers et sécurisés avec une transparence totale",
        feat5_title: "Communauté de soutien",
        feat5_desc: "Rejoignez une communauté de spécialistes du marketing à succès",
        feat6_title: "Support 24/7",
        feat6_desc: "Équipe de support disponible 24h/24",
        how_badge: "Comment commencer ?",
        how_title: "Un parcours de réussite en",
        how_subtitle: "6 étapes faciles",
        step1_title: "Créer un compte",
        step1_desc: "Inscrivez votre compte gratuitement en quelques minutes",
        step2_title: "Choisir vos produits",
        step2_desc: "Parcourez des milliers de produits à haut rendement",
        step3_title: "Connecter la boutique",
        step3_desc: "Connectez facilement vos produits à votre plateforme",
        step4_title: "Commencer le marketing",
        step4_desc: "Utilisez nos outils marketing avancés",
        step5_title: "Suivi des commandes",
        step5_desc: "Suivez toutes les ventes dans un seul tableau de bord",
        step6_title: "Recevez vos gains",
        step6_desc: "Transferts sécurisés et continus de vos gains",
        model_title: "Choisissez votre chemin",
        model_subtitle: "vers le succès",
        model_desc: "Que vous souhaitiez commercialiser les produits d'autres personnes ou présenter vos propres produits",
        model_partner_title: "Partenaire marketing",
        model_partner_desc: "Rejoignez notre vaste réseau de spécialistes du marketing et gagnez des commissions exceptionnelles en promouvant des produits de haute qualité.",
        model_partner_item1: "Commissions jusqu'à 70%",
        model_partner_item2: "Des milliers de produits populaires",
        model_partner_item3: "Outils marketing avancés",
        model_partner_item4: "Paiement hebdomadaire",
        model_partner_item5: "Support technique complet",
        model_partner_cta: "Commencez en tant que partenaire",
        model_seller_title: "Vendeur",
        model_seller_desc: "Présentez vos produits à des milliers de spécialistes du marketing professionnels et élargissez votre portée avec des ventes garanties.",
        model_seller_item1: "Vaste réseau de marketeurs",
        model_seller_item2: "Gestion complète des commandes",
        model_seller_item3: "Suivi des ventes",
        model_seller_item4: "Paiement régulier",
        model_seller_item5: "Protection des produits",
        model_seller_cta: "Commencez en tant que vendeur",
        services_badge: "Nos services intégrés",
        services_title: "Plus qu'une simple plateforme",
        services_subtitle: "Un partenariat complet",
        service1_title: "Relation directe",
        service1_desc: "Relation directe sans intermédiaire avec une assurance complète des transactions et une garantie de la qualité des produits et services fournis aux clients finaux.",
        service1_feat1: "Garantie de qualité",
        service1_feat2: "Suivi direct",
        service1_feat3: "Sécurité totale",
        service1_feat4: "Transparence",
        service2_title: "Formation et supervision",
        service2_desc: "Programmes de formation spécialisés et supervision continue d'experts de l'industrie pour assurer votre succès et maximiser votre utilisation de la plateforme.",
        service2_feat1: "Cours spécialisés",
        service2_feat2: "Supervision directe",
        service2_feat3: "Mises à jour continues",
        service2_feat4: "Support d'experts",
        service3_title: "Centre d'appels",
        service3_desc: "Service client intégré 24h/24 pour répondre à tous vos besoins et assurer la satisfaction de vos clients et l'obtention des meilleurs résultats.",
        service3_feat1: "Support technique 24/7",
        service3_feat2: "Suivi des commandes",
        service3_feat3: "Résolution de problèmes",
        service3_feat4: "Consultations",
        products_badge: "Produits populaires",
        products_title: "Découvrez les produits",
        products_subtitle: "les plus rentables",
        products_cta: "Explorer tous les produits",
        cta_badge: "Commencez votre voyage maintenant",
        cta_title: "Il est temps de",
        cta_subtitle: "changer votre vie",
        cta_desc: "Rejoignez des milliers de personnes qui ont transformé leur passion en une source de revenus durable. Vous n'avez pas besoin d'expérience, tout ce dont vous avez besoin c'est la volonté de commencer.",
        cta_register: "Inscrivez-vous gratuitement maintenant",
        cta_consult: "Contactez un conseiller",
        cta_stat_marketers: "Spécialistes du marketing à succès",
        cta_stat_profits: "Bénéfices distribués",
        cta_stat_satisfaction: "Satisfaction client",
        cta_stat_support: "Support technique",
      },
      about: {
        hero_title_1: "Redéfinir",
        hero_title_2: "le marketing d'affiliation",
        hero_desc: "Nous croyons que le succès de nos spécialistes du marketing est notre succès. C'est pourquoi nous construisons une plateforme qui rend la génération de revenus facile, transparente et gratifiante pour tous.",
        vision_title: "Notre vision",
        vision_desc: "Nous aspirons à créer un monde où toute personne ayant une passion et un contenu de valeur peut générer des revenus durables grâce au marketing d'affiliation, sans avoir besoin d'expérience technique préalable.",
        vision_item1: "Autonomiser un million de marketeurs d'ici 2025",
        vision_item2: "Exporter les talents arabes dans le monde",
        vision_item3: "Créer une économie numérique durable",
        mission_title: "Notre mission",
        mission_desc: "Construire des ponts entre les marques leaders et les créateurs de contenu talentueux, en fournissant les outils et la technologie qui rendent le partenariat réussi pour les deux parties.",
        mission_item1: "Simplifier les opérations marketing",
        mission_item2: "Garantir une transparence totale",
        mission_item3: "Fournir les meilleurs produits",
        story_badge: "Notre histoire",
        story_title: "Un voyage qui a commencé",
        story_subtitle: "par une simple question",
        story_quote: '"D\'une petite idée à une plateforme qui change la vie de milliers de personnes"',
        story_p1: "En 2019, nous avons remarqué un écart important entre les marques cherchant des spécialistes du marketing fiables et les créateurs de contenu cherchant des produits de valeur à promouvoir. Tout le monde perdait.",
        story_p2: "Nous avons décidé de construire le pont qui manquait à cette industrie. Nous avons commencé avec une petite équipe de passionnés, et nous nous sommes fixé un seul objectif : rendre le marketing d'affiliation équitable pour tous.",
        story_p3: "Aujourd'hui, nous sommes fiers d'avoir fourni des solutions qui ont changé la vie de plus de 50 000 spécialistes du marketing, et d'avoir aidé des milliers de marques à atteindre leur public cible.",
        story_cta: "Rejoignez notre voyage",
        stats_badge: "Notre impact en chiffres",
        stats_title: "Des réussites qui parlent",
        stats_subtitle: "d'elles-mêmes",
        stat1_label: "Spécialistes du marketing à succès",
        stat1_desc: "Nous rejoignent mensuellement",
        stat2_label: "Commissions payées",
        stat2_desc: "Annuellement aux marketeurs",
        stat3_label: "Marques",
        stat3_desc: "Populaires avec nous",
        stat4_label: "Satisfaction client",
        stat4_desc: "Taux de satisfaction général",
        values_title: "Nos valeurs",
        values_subtitle: "fondamentales",
        values_desc: "Les principes par lesquels nous travaillons et progressons à chaque étape",
        value1_title: "Transparence",
        value1_desc: "Tout est clair et annoncé, des commissions aux paiements",
        value2_title: "Équité",
        value2_desc: "Nous garantissons les droits de tous et travaillons pour les deux parties",
        value3_title: "Communauté",
        value3_desc: "Nous construisons un environnement favorable à l'apprentissage et à la croissance partagée",
        value4_title: "Évolution",
        value4_desc: "Nous évoluons constamment pour offrir le meilleur à nos partenaires",
        team_badge: "Les esprits créatifs",
        team_title: "Rencontrez l'équipe",
        team_subtitle: "de direction",
        team_member1_role: "CEO",
        team_member1_bio: "15+ ans dans le marketing numérique, ancien VP chez Google",
        team_member2_role: "CTO",
        team_member2_bio: "Ancien ingénieur chez Facebook, diplômé du MIT",
        team_member3_role: "CMO",
        team_member3_bio: "Ancienne responsable marketing chez Amazon, experte en croissance",
        team_member4_role: "COO",
        team_member4_bio: "Spécialiste des opérations, MBA de Stanford",
        cta_badge: "Un avenir radieux vous attend",
        cta_title: "Faites partie de",
        cta_subtitle: "notre histoire de réussite",
        cta_desc: "Rejoignez une communauté de personnes qui ont transformé leur passion en source de revenus. Commencez votre voyage aujourd'hui et laissez-nous vous accompagner vers le succès.",
        cta_join: "Rejoignez-nous maintenant",
        cta_consult: "Contactez un conseiller",
      },
      contact: {
        hero_title: "Commençons une",
        hero_subtitle: "conversation",
        hero_desc: "Vous avez des questions ? Des idées ? Nous sommes là pour vous écouter. Notre équipe de support est prête à vous aider pour toute demande.",
        card_email_title: "E-mail",
        card_email_contact: "support.example.com",
        card_email_desc: "Réponse sous 4 heures ouvrables",
        card_phone_title: "Téléphone",
        card_phone_contact: "+966 55 123 4567",
        card_phone_desc: "Dimanche - Jeudi 9h - 17h",
        card_office_title: "Bureau",
        card_office_contact: "Casablanca, Maroc",
        card_office_desc: "Réunions sur rendez-vous",
        card_response_title: "Temps de réponse",
        card_response_contact: "24/7",
        card_response_desc: "Support technique continu",
        form_success_title: "Votre message a été envoyé !",
        form_success_desc: "Merci de nous avoir contactés. Notre équipe vous répondra dès que possible. Nous répondons généralement dans les 24 heures ouvrables.",
        form_success_another: "Envoyer un autre message",
        form_title: "Envoyez votre message",
        form_subtitle: "Nous vous répondrons sous 24 heures",
        form_name_label: "Nom complet *",
        form_name_placeholder: "Exemple : Mohamed Ahmed",
        form_email_label: "E-mail *",
        form_email_placeholder: "email.example.com",
        form_subject_label: "Sujet *",
        form_subject_placeholder: "De quoi voulez-vous discuter ?",
        form_message_label: "Votre message *",
        form_message_placeholder: "Dites-nous les détails de votre demande...",
        form_submitting: "Envoi en cours...",
        form_submit: "Envoyer le message",
        sidebar_why_title: "Pourquoi nous contacter ?",
        sidebar_why_item1: "Questions sur le programme de partenariat",
        sidebar_why_item2: "Support technique de la plateforme",
        sidebar_why_item3: "Suggestions et améliorations",
        sidebar_why_item4: "Collaboration avec les marques",
        sidebar_why_item5: "Consultations marketing",
        sidebar_why_item6: "Problèmes de paiement",
        faq_title: "FAQ",
        faq_q1: "Combien de temps pour une réponse ?",
        faq_a1: "Nous répondons à toutes les demandes dans les 24 heures ouvrables.",
        faq_q2: "Le support est-il gratuit ?",
        faq_a2: "Oui, tous les services de support sont gratuits pour les spécialistes du marketing inscrits.",
        faq_q3: "Quels sont les horaires de travail ?",
        faq_a3: "Le support technique est disponible 24/7 via tickets et e-mail.",
        faq_browse: "Voir toutes les questions",
        social_proof_text: "Support incroyable ! L'équipe de support m'a aidé à résoudre mon problème en quelques heures. Très professionnels.",
        social_proof_author: "- Ahmed S., marketeur depuis 2020",
        location_title: "Visitez nos",
        location_subtitle: "bureaux",
        location_desc: "Nous sommes toujours heureux de vous recevoir dans nos bureaux pour discuter des collaborations et des partenariats",
        location_name: "Casablanca, Maroc",
        office_hours_title: "Horaires d'ouverture",
        office_hours_days: "Dimanche - Jeudi",
        office_hours_time: "9h00 - 17h00",
        office_direct_title: "Appel direct",
        office_direct_desc: "Pour les affaires urgentes",
        office_email_title: "E-mail rapide",
        office_email_desc: "Pour les affaires générales",
        cta_badge: "Prêt à commencer ?",
        cta_title: "Commençons la conversation",
        cta_subtitle: "aujourd'hui",
        cta_desc: "Notre équipe est impatiente de vous connaître et de vous aider dans votre parcours. Contactez-nous maintenant et commencez à atteindre vos objectifs.",
        cta_start_chat: "Commencer une conversation",
        cta_schedule: "Planifier un appel",
      },
      policy: {
        hero_title: "Votre vie privée",
        hero_subtitle: "notre priorité",
        hero_desc: "Nous croyons que votre vie privée est un droit fondamental. Nous offrons ici une transparence totale sur la façon dont nous protégeons vos données.",
        nav_data: "Vos données",
        nav_protection: "Protection",
        nav_rights: "Vos droits",
        nav_contact: "Contact",
        nav_updates: "Mises à jour",
        sidebar_key_title: "Points essentiels",
        sidebar_key_item1: "Nous ne vendons pas vos données à des tiers",
        sidebar_key_item2: "Transparence totale dans la collecte des données",
        sidebar_key_item3: "Droit d'accès et de contrôle de vos données",
        sidebar_key_item4: "Protection par chiffrement de premier ordre",
        sidebar_questions_title: "Des questions ?",
        sidebar_questions_desc: "Vous avez une question sur la politique de confidentialité ?",
        sidebar_questions_cta: "Contactez-nous",
        section1_title: "Données que nous collectons",
        section1_account_title: "Informations du compte",
        section1_account_desc: "Nous collectons les informations que vous fournissez lors de la création ou de la mise à jour de votre compte :",
        section1_basic_title: "Informations de base",
        section1_basic_item1: "Nom complet",
        section1_basic_item2: "E-mail",
        section1_basic_item3: "Numéro de téléphone",
        section1_basic_item4: "Adresse",
        section1_payment_title: "Informations de paiement",
        section1_payment_item1: "Données de virement bancaire",
        section1_payment_item2: "Informations fiscales",
        section1_payment_item3: "Historique des paiements",
        section1_payment_item4: "Préférences de paiement",
        section1_usage_title: "Données d'utilisation",
        section1_usage_desc: "Nous collectons des données d'utilisation pour améliorer nos services :",
        section1_usage_text: "Activité sur la plateforme, interactions avec les produits, données de performance et analyses d'utilisation pour améliorer votre expérience et fournir des recommandations personnalisées.",
        section2_title: "Protection de vos données",
        section2_subtitle: "Protection multicouche",
        section2_tech_title: "Sécurité technique",
        section2_tech_item1: "Chiffrement AES-256 des données",
        section2_tech_item2: "SSL/TLS 1.3 pour le transport",
        section2_tech_item3: "Pare-feux avancés",
        section2_tech_item4: "Surveillance continue des menaces",
        section2_ops_title: "Mesures opérationnelles",
        section2_ops_item1: "Accès limité aux données",
        section2_ops_item2: "Formation à la sécurité des employés",
        section2_ops_item3: "Audits de sécurité réguliers",
        section2_ops_item4: "Plans de reprise après sinistre",
        section3_title: "Vos droits légaux",
        right1_title: "Droit d'accès",
        right1_desc: "Demander une copie de vos données personnelles",
        right2_title: "Droit de rectification",
        right2_desc: "Corriger les données inexactes",
        right3_title: "Droit de suppression",
        right3_desc: "Demander la suppression de vos données personnelles",
        right4_title: "Droit à la portabilité",
        right4_desc: "Transférer vos données vers un autre service",
        section4_title: "Partage des données",
        section4_subtitle: "Nous ne vendons pas vos données",
        section4_desc: "Nous ne vendons ni ne louons vos données personnelles à des tiers à des fins marketing. Nous partageons les données uniquement dans les cas suivants :",
        section4_item1: "Avec les prestataires de services nécessaires au fonctionnement de la plateforme",
        section4_item2: "Aux autorités de régulation lorsque requis par la loi",
        section4_item3: "En cas de fusion ou d'acquisition de l'entreprise",
        section4_item4: "Pour protéger nos droits ou la sécurité des utilisateurs",
        section5_title: "Contactez-nous",
        section5_desc: "Vous avez des questions ou des préoccupations concernant la politique de confidentialité ? Nous sommes là pour vous aider.",
        section5_officer_title: "Responsable de la protection des données",
        section5_officer_email: "privacy.yourcompany.com",
        section5_officer_response: "Réponse sous 48 heures ouvrables",
        section5_address_title: "Adresse postale",
        section5_address_company: "Société Naajihoun pour le Marketing",
        section5_address_city: "Riyad, Arabie Saoudite",
        section5_address_box: "Boîte postale : 12345",
        section6_title: "Mises à jour de la politique",
        section6_desc: "Nous pouvons mettre à jour cette politique de temps à autre. Nous vous informerons de tout changement substantiel :",
        section6_item1: "Affichage de notifications sur la plateforme",
        section6_item2: "Envoi d'e-mails aux inscrits",
        section6_item3: "Mise à jour de la date de 'Dernière mise à jour' sur cette page",
        section6_item4: "Demande de confirmation pour les changements importants",
        final_badge: "Nous sommes fiers de protéger votre vie privée",
        final_desc: "Nous nous engageons à une transparence totale et une protection maximale de vos données. Nous considérons cela comme une responsabilité que nous prenons très au sérieux.",
        final_cta: "Contacter le responsable de la protection des données",
        final_faq: "FAQ",
      },
      
      bank_select: {
        label_bank_name: "Nom de la banque",
        placeholder_bank: "Choisir la banque",
      },
      components: {
        homeProducts: {
          loading: "Chargement...",
          no_products: "Aucun produit disponible",
          commission: "Commission {commission}MAD",
          earn: "Gagnez: {earnings}MAD",
          promote_now: "Promouvoir",
        },
      },
    },
  },

  activity_logs: {
    title: "Journal d'activité",
    subtitle: "Console de surveillance des activités du système",
    entries: "entrées",
    search: "Rechercher dans les logs...",
    search_btn: "Rechercher",
    filters: "Filtres",
    loading: "Chargement des logs d'activité...",
    loading_more: "Chargement plus...",
    no_logs: "Aucun log d'activité trouvé",
    end: "FIN DES LOGS",
    details: {
      ip_address: 'Adresse IP',
      user_agent: 'Navigateur',
      user_id: 'ID Utilisateur',
      name: 'Nom',
      email: 'Email',
      role: 'Rôle',
      order_id: 'ID Commande',
      client_id: 'ID Client',
      cart_id: 'ID Panier',
      total: 'Total',
      changes: 'Modifications',
      product_id: 'ID Produit',
      shopify_product_id: 'ID Shopify',
      youcan_product_id: 'ID YouCan',
      category_id: 'ID Catégorie',
      title: 'Titre',
      variant_id: 'ID Variante',
      fournisseur_id: 'ID Fournisseur',
      annonce_id: 'ID Annonce',
      reclamation_id: 'ID Réclamation',
      blacklist_id: 'ID Blacklist',
      invoice_id: 'ID Facture',
      count: 'Nombre',
      status: 'Statut',
      old_status: 'Ancien statut',
      new_status: 'Nouveau statut',
      changed_by: 'Modifié par',
      livreur_id: 'ID Livreur',
      company: 'Société',
      order_ids: 'IDs Commandes',
      updated_count: 'Mis à jour',
      confirmed_count: 'Confirmées',
      total_count: 'Total',
      scan_data: 'Données scan',
      webhook_payload: 'Payload Webhook',
      success_count: 'Succès',
      integration_id: 'ID Intégration',
      app_name: 'Application',
      config_id: 'ID Configuration',
      company_id: 'ID Société',
      payment_id: 'ID Paiement',
      amount: 'Montant',
      phone: 'Téléphone',
      results: 'Résultats',
    },
    actions: {
      user: {
        login: 'Connexion',
        logout: 'Déconnexion',
        password_changed: 'Mot de passe modifié',
        registered: 'Utilisateur inscrit',
        staff_registered: 'Staff inscrit',
        deleted: 'Utilisateur supprimé',
        seller_status_changed: 'Statut vendeur modifié',
        profile_updated: 'Profil mis à jour',
        saller_updated: 'Vendeur modifié',
        saller_profile_updated: 'Profil vendeur mis à jour',
        admin_profile_updated: 'Profil admin mis à jour',
        confirmator_profile_updated: 'Profil confirmateur mis à jour',
      },
      order: {
        created: 'Commande créée',
        cart_created: 'Panier créé',
        updated: 'Commande modifiée',
        deleted: 'Commande supprimée',
        confirmed: 'Commande confirmée',
        status_changed: 'Statut commande modifié',
        scanned: 'Commande scannée',
        imported: 'Commande importée',
        ozon_status_changed: 'Statut Ozon modifié',
        livreur_status_changed: 'Statut livreur modifié',
        sent_to_delivery: 'Envoyé en livraison',
        delivery_sync: 'Sync livraison',
        api_created: 'Commande créée par API',
      },
      webhook: {
        turboliv: 'Webhook Turboliv',
        irsaliyat: 'Webhook Irsaliyat',
        sift: 'Webhook Sift',
        nexship: 'Webhook Nexship',
        nexship_v2: 'Webhook Nexship v2',
      },
      product: {
        created: 'Produit créé',
        updated: 'Produit modifié',
        deleted: 'Produit supprimé',
        pin_toggled: 'Épinglage produit',
        shopify_sync: 'Sync Shopify',
        youcan_sync: 'Sync YouCan',
        shopify_bulk_sync: 'Sync Shopify (lot)',
        youcan_bulk_sync: 'Sync YouCan (lot)',
      },
      role: {
        created: 'Rôle créé',
        updated: 'Rôle modifié',
        deleted: 'Rôle supprimé',
      },
      category: {
        created: 'Catégorie créée',
        updated: 'Catégorie modifiée',
        deleted: 'Catégorie supprimée',
      },
      variant: {
        created: 'Variante créée',
        updated: 'Variante modifiée',
        deleted: 'Variante supprimée',
      },
      fournisseur: {
        created: 'Fournisseur créé',
        updated: 'Fournisseur modifié',
        deleted: 'Fournisseur supprimé',
      },
      annonce: {
        created: 'Annonce créée',
        updated: 'Annonce modifiée',
        deleted: 'Annonce supprimée',
      },
      reclamation: {
        created: 'Réclamation créée',
        messages_seen: 'Messages réclamation vus',
      },
      blacklist: {
        added: 'Ajouté à la blacklist',
        removed: 'Retiré de la blacklist',
      },
      invoice: {
        saller_paid: 'Facture vendeur payée',
        confirmator_paid: 'Facture confirmateur payée',
        livreur_paid: 'Facture livreur payée',
        saller_auto_generated: 'Facture vendeur auto-générée',
        confirmator_auto_generated: 'Facture confirmateur auto-générée',
        livreur_auto_generated: 'Facture livreur auto-générée',
      },
      config: {
        updated: 'Configuration modifiée',
      },
      payment_system: {
        updated: 'Système de paiement modifié',
      },
      delivery_company: {
        updated: 'Société livraison modifiée',
      },
      integration: {
        oauth_initiated: 'OAuth initié',
        updated: 'Intégration modifiée',
      },
      api_key: {
        generated: 'Clé API générée',
        webhook_url: 'URL webhook API enregistrée',
        webhook_status: 'Statut webhook mis à jour',
        revoked: 'Clé API révoquée',
      },
    },
  },
};

export default fr;
